webpackJsonp([20],{

/***/ "/Eu8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "4VHz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',[(_vm.isKeepAlive)?_c('router-view',{staticClass:"app-content"}):_vm._e()],1),_vm._v(" "),(!_vm.isKeepAlive)?_c('router-view',{staticClass:"app-content"}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowRefresh),expression:"isShowRefresh"}],staticStyle:{"position":"fixed","bottom":"130px","right":"50px","width":"30px","height":"30px","background-color":"#dd4444","border-radius":"50%","z-index":"999999"},attrs:{"onclick":"window.location.reload();"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6NR2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pnf-view"},[_c('h1',{staticClass:"pnf-title"},[_vm._v("\n        "+_vm._s(_vm.title)+" ...\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "B9BE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'pageNotFound',
    data: function data() {
        return {
            title: '页面跑到火星去了'
        };
    }
});

/***/ }),

/***/ "BFDI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_plugins_wechat_index_js__ = __webpack_require__("n6Wb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_mutation_types__ = __webpack_require__("iMSY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_const__ = __webpack_require__("GwN5");



var _mutations;





__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vux_src_plugins_wechat_index_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);

window.wx = __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].wechat;





var state = {
  apiInfo: ''
};

var getters = {
  setShareInfo: function setShareInfo(state) {
    return state.apiInfo;
  }
};

var actions = {
  setShareInfo: function setShareInfo(_ref, options) {
    var commit = _ref.commit;

    var uri = __WEBPACK_IMPORTED_MODULE_6__config_const__["c" /* API_SHARE_URL */] + "?url=" + encodeURIComponent(window.location.href.split('#')[0]);
    var setWxShare = function setWxShare(options) {
      window.wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: options.data.appid, // 必填，公众号的唯一标识
        timestamp: options.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: options.data.nonceStr, // 必填，生成签名的随机串
        signature: options.data.signature, // 必填，签名，见附录1
        jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone']
      });
      window.wx.ready(function () {
        var shareInfo = {
          title: options.shareInfo.title,
          desc: options.shareInfo.desc,
          link: options.shareInfo.link, // 分享链接
          imgUrl: options.shareInfo.imgUrl, // 分享图标
          type: 'link', // 分享类型,music、video或link，不填默认为link
          dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
          success: function success() {},
          cancel: function cancel() {}
        };
        wx.onMenuShareTimeline(shareInfo);
        wx.onMenuShareAppMessage(shareInfo);
        wx.onMenuShareQQ(shareInfo);
        wx.onMenuShareWeibo(shareInfo);
        wx.onMenuShareQZone(shareInfo);
      });
    };
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.get(uri).then(function (res, err) {
        resolve(res.data);
      }, function (res) {
        reject(res.data);
      });
    }).then(function (res) {
      commit(__WEBPACK_IMPORTED_MODULE_5__config_mutation_types__["e" /* API_INFO */], res);
      setWxShare({
        data: res,
        shareInfo: options.shareInfo
      });
    }, function (err) {
      commit(__WEBPACK_IMPORTED_MODULE_5__config_mutation_types__["m" /* APP_FAILURE */], '获取微信分享信息失败');
    });
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__config_mutation_types__["e" /* API_INFO */], function (state, data) {
  state.apiInfo = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__config_mutation_types__["m" /* APP_FAILURE */], function (state, data) {
  state.apiInfo = data;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "Bfwr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("Z5JB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_594febdc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("XJvr");
function injectStyle (ssrContext) {
  __webpack_require__("SZ1B")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_594febdc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DF5F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator__ = __webpack_require__("Zzip");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol__ = __webpack_require__("5QVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol__);




var _typeof = "function" == typeof __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a && "symbol" == __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator___default.a) ? function (n) {
  return typeof n === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(n);
} : function (n) {
  return n && "function" == typeof __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a && n.constructor === __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a && n !== __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a.prototype ? "symbol" : typeof n === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(n);
};!function (n) {
  var i = { setting: {}, loading: "", open: function open() {
      this.loading ? this.loading.style.display = "flex" : (this.css(this.cssString()), this.loading = document.createElement("div"), this.loading.className = "loading", this.loading.innerHTML = '\n        <div class="load">\n            <div class="m-load2">\n              <div class="line">\n                  <div></div>\n                  <div></div>\n                  <div></div>\n                  <div></div>\n                  <div></div>\n                  <div></div>\n              </div>\n              <div class="circlebg"></div>\n            </div>\n            <div>加载中...</div>\n        </div>\n\n      ', document.body.appendChild(this.loading));
    }, css: function css() {
      for (var n = document, i = !0, t = n.getElementsByTagName("style"), e = 0, d = t.length; e < d; e++) {
        "loading" == t[e].getAttribute("idOnce") && (i = !1);
      }if (i) {
        var o = n.createElement("style");if (o.setAttribute("idOnce", "loading"), o.styleSheet) o.styleSheet.cssText = arguments[0];else {
          var a = n.createTextNode(arguments[0]);o.appendChild(a);
        }n.head.appendChild(o);
      }
    }, cssString: function cssString() {
      return "\n     .loading{\n       position: fixed;\n       top:0;\n       left: 0;\n       right: 0;\n       bottom: 0;\n       z-index: 99;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n\n\n    .load{\n        width:100px;\n        height:110px;\n        background: rgba(0,0,0,0.7);\n        margin: 0 auto;\n        border-radius: 6px;\n        color: #fff;\n        font-size: 14px;\n        text-align:center;\n\n    }\n\n    .m-load2 {\n        width: 36px;\n        height: 36px;\n        margin: 20px auto;\n    }\n\n\n\n    .m-load2 {\n        position: relative;\n    }\n\n    .m-load2 .line div {\n        position: absolute;\n        left: 16px;\n        top: 0;\n        width: 3px;\n        height: 36px;\n    }\n\n    .m-load2 .line div:before, .m-load2 .line div:after {\n        content: '';\n        display: block;\n        height: 50%;\n        background: #fcfcfc;\n        border-radius: 5px;\n    }\n\n    .m-load2 .line div:nth-child(2) {\n        -webkit-transform: rotate(30deg);\n    }\n\n    .m-load2 .line div:nth-child(3) {\n        -webkit-transform: rotate(60deg);\n    }\n\n    .m-load2 .line div:nth-child(4) {\n        -webkit-transform: rotate(90deg);\n    }\n\n    .m-load2 .line div:nth-child(5) {\n        -webkit-transform: rotate(120deg);\n    }\n\n    .m-load2 .line div:nth-child(6) {\n        -webkit-transform: rotate(150deg);\n    }\n\n    .m-load2 .circlebg {\n        position: absolute;\n        left: 50%;\n        top: 50%;\n        width: 18px;\n        height: 18px;\n        margin: -9px 0 0 -9px;\n        background: #535353;\n        border-radius: 18px;\n    }\n\n    @-webkit-keyframes load {\n        0% {\n            opacity: 0;\n        }\n        100% {\n            opacity: 1;\n        }\n    }\n\n    .m-load2 .line div:nth-child(1):before {\n        -webkit-animation: load 1.2s linear 0s infinite;\n    }\n\n    .m-load2 .line div:nth-child(2):before {\n        -webkit-animation: load 1.2s linear 0.1s infinite;\n    }\n\n    .m-load2 .line div:nth-child(3):before {\n        -webkit-animation: load 1.2s linear 0.2s infinite;\n    }\n\n    .m-load2 .line div:nth-child(4):before {\n        -webkit-animation: load 1.2s linear 0.3s infinite;\n    }\n\n    .m-load2 .line div:nth-child(5):before {\n        -webkit-animation: load 1.2s linear 0.4s infinite;\n    }\n\n    .m-load2 .line div:nth-child(6):before {\n        -webkit-animation: load 1.2s linear 0.5s infinite;\n    }\n\n    .m-load2 .line div:nth-child(1):after {\n        -webkit-animation: load 1.2s linear 0.6s infinite;\n    }\n\n    .m-load2 .line div:nth-child(2):after {\n        -webkit-animation: load 1.2s linear 0.7s infinite;\n    }\n\n    .m-load2 .line div:nth-child(3):after {\n        -webkit-animation: load 1.2s linear 0.8s infinite;\n    }\n\n    .m-load2 .line div:nth-child(4):after {\n        -webkit-animation: load 1.2s linear 0.9s infinite;\n    }\n\n    .m-load2 .line div:nth-child(5):after {\n        -webkit-animation: load 1.2s linear 1s infinite;\n    }\n\n    .m-load2 .line div:nth-child(6):after {\n        -webkit-animation: load 1.2s linear 1.1s infinite;\n    }\n    ";
    }, close: function close() {
      this.loading && (this.loading.style.display = "none");
    } };"object" === (void 0 === n ? "undefined" : _typeof(n)) && "object" === _typeof(n.document) && (n.Indicator = i);
}(window);

/***/ }),

/***/ "DNrh":
/***/ (function(module, exports) {

/**
 * jshashes - https://github.com/h2non/jshashes
 * Released under the "New BSD" license
 *
 * Algorithms specification:
 *
 * MD5 - http://www.ietf.org/rfc/rfc1321.txt
 * RIPEMD-160 - http://homes.esat.kuleuven.be/~bosselae/ripemd160.html
 * SHA1   - http://csrc.nist.gov/publications/fips/fips180-4/fips-180-4.pdf
 * SHA256 - http://csrc.nist.gov/publications/fips/fips180-4/fips-180-4.pdf
 * SHA512 - http://csrc.nist.gov/publications/fips/fips180-4/fips-180-4.pdf
 * HMAC - http://www.ietf.org/rfc/rfc2104.txt
 */
var Hashes;

function utf8Encode(str) {
  var x,
      y,
      output = '',
      i = -1,
      l;

  if (str && str.length) {
    l = str.length;
    while ((i += 1) < l) {
      /* Decode utf-16 surrogate pairs */
      x = str.charCodeAt(i);
      y = i + 1 < l ? str.charCodeAt(i + 1) : 0;
      if (0xD800 <= x && x <= 0xDBFF && 0xDC00 <= y && y <= 0xDFFF) {
        x = 0x10000 + ((x & 0x03FF) << 10) + (y & 0x03FF);
        i += 1;
      }
      /* Encode output as utf-8 */
      if (x <= 0x7F) {
        output += String.fromCharCode(x);
      } else if (x <= 0x7FF) {
        output += String.fromCharCode(0xC0 | x >>> 6 & 0x1F, 0x80 | x & 0x3F);
      } else if (x <= 0xFFFF) {
        output += String.fromCharCode(0xE0 | x >>> 12 & 0x0F, 0x80 | x >>> 6 & 0x3F, 0x80 | x & 0x3F);
      } else if (x <= 0x1FFFFF) {
        output += String.fromCharCode(0xF0 | x >>> 18 & 0x07, 0x80 | x >>> 12 & 0x3F, 0x80 | x >>> 6 & 0x3F, 0x80 | x & 0x3F);
      }
    }
  }
  return output;
}

function utf8Decode(str) {
  var i,
      ac,
      c1,
      c2,
      c3,
      arr = [],
      l;
  i = ac = c1 = c2 = c3 = 0;

  if (str && str.length) {
    l = str.length;
    str += '';

    while (i < l) {
      c1 = str.charCodeAt(i);
      ac += 1;
      if (c1 < 128) {
        arr[ac] = String.fromCharCode(c1);
        i += 1;
      } else if (c1 > 191 && c1 < 224) {
        c2 = str.charCodeAt(i + 1);
        arr[ac] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        i += 2;
      } else {
        c2 = str.charCodeAt(i + 1);
        c3 = str.charCodeAt(i + 2);
        arr[ac] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        i += 3;
      }
    }
  }
  return arr.join('');
}

/**
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */

function safe_add(x, y) {
  var lsw = (x & 0xFFFF) + (y & 0xFFFF),
      msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 0xFFFF;
}

/**
 * Bitwise rotate a 32-bit number to the left.
 */

function bit_rol(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}

/**
 * Convert a raw string to a hex string
 */

function rstr2hex(input, hexcase) {
  var hex_tab = hexcase ? '0123456789ABCDEF' : '0123456789abcdef',
      output = '',
      x,
      i = 0,
      l = input.length;
  for (; i < l; i += 1) {
    x = input.charCodeAt(i);
    output += hex_tab.charAt(x >>> 4 & 0x0F) + hex_tab.charAt(x & 0x0F);
  }
  return output;
}

/**
 * Encode a string as utf-16
 */

function str2rstr_utf16le(input) {
  var i,
      l = input.length,
      output = '';
  for (i = 0; i < l; i += 1) {
    output += String.fromCharCode(input.charCodeAt(i) & 0xFF, input.charCodeAt(i) >>> 8 & 0xFF);
  }
  return output;
}

function str2rstr_utf16be(input) {
  var i,
      l = input.length,
      output = '';
  for (i = 0; i < l; i += 1) {
    output += String.fromCharCode(input.charCodeAt(i) >>> 8 & 0xFF, input.charCodeAt(i) & 0xFF);
  }
  return output;
}

/**
 * Convert an array of big-endian words to a string
 */

function binb2rstr(input) {
  var i,
      l = input.length * 32,
      output = '';
  for (i = 0; i < l; i += 8) {
    output += String.fromCharCode(input[i >> 5] >>> 24 - i % 32 & 0xFF);
  }
  return output;
}

/**
 * Convert an array of little-endian words to a string
 */

function binl2rstr(input) {
  var i,
      l = input.length * 32,
      output = '';
  for (i = 0; i < l; i += 8) {
    output += String.fromCharCode(input[i >> 5] >>> i % 32 & 0xFF);
  }
  return output;
}

/**
 * Convert a raw string to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 */

function rstr2binl(input) {
  var i,
      l = input.length * 8,
      output = Array(input.length >> 2),
      lo = output.length;
  for (i = 0; i < lo; i += 1) {
    output[i] = 0;
  }
  for (i = 0; i < l; i += 8) {
    output[i >> 5] |= (input.charCodeAt(i / 8) & 0xFF) << i % 32;
  }
  return output;
}

/**
 * Convert a raw string to an array of big-endian words
 * Characters >255 have their high-byte silently ignored.
 */

function rstr2binb(input) {
  var i,
      l = input.length * 8,
      output = Array(input.length >> 2),
      lo = output.length;
  for (i = 0; i < lo; i += 1) {
    output[i] = 0;
  }
  for (i = 0; i < l; i += 8) {
    output[i >> 5] |= (input.charCodeAt(i / 8) & 0xFF) << 24 - i % 32;
  }
  return output;
}

/**
 * Convert a raw string to an arbitrary string encoding
 */

function rstr2any(input, encoding) {
  var divisor = encoding.length,
      remainders = Array(),
      i,
      q,
      x,
      ld,
      quotient,
      dividend,
      output,
      full_length;

  /* Convert to an array of 16-bit big-endian values, forming the dividend */
  dividend = Array(Math.ceil(input.length / 2));
  ld = dividend.length;
  for (i = 0; i < ld; i += 1) {
    dividend[i] = input.charCodeAt(i * 2) << 8 | input.charCodeAt(i * 2 + 1);
  }

  /**
   * Repeatedly perform a long division. The binary array forms the dividend,
   * the length of the encoding is the divisor. Once computed, the quotient
   * forms the dividend for the next step. We stop when the dividend is zerHashes.
   * All remainders are stored for later use.
   */
  while (dividend.length > 0) {
    quotient = Array();
    x = 0;
    for (i = 0; i < dividend.length; i += 1) {
      x = (x << 16) + dividend[i];
      q = Math.floor(x / divisor);
      x -= q * divisor;
      if (quotient.length > 0 || q > 0) {
        quotient[quotient.length] = q;
      }
    }
    remainders[remainders.length] = x;
    dividend = quotient;
  }

  /* Convert the remainders to the output string */
  output = '';
  for (i = remainders.length - 1; i >= 0; i--) {
    output += encoding.charAt(remainders[i]);
  }

  /* Append leading zero equivalents */
  full_length = Math.ceil(input.length * 8 / (Math.log(encoding.length) / Math.log(2)));
  for (i = output.length; i < full_length; i += 1) {
    output = encoding[0] + output;
  }
  return output;
}

/**
 * Convert a raw string to a base-64 string
 */

function rstr2b64(input, b64pad) {
  var tab = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',
      output = '',
      len = input.length,
      i,
      j,
      triplet;
  b64pad = b64pad || '=';
  for (i = 0; i < len; i += 3) {
    triplet = input.charCodeAt(i) << 16 | (i + 1 < len ? input.charCodeAt(i + 1) << 8 : 0) | (i + 2 < len ? input.charCodeAt(i + 2) : 0);
    for (j = 0; j < 4; j += 1) {
      if (i * 8 + j * 6 > input.length * 8) {
        output += b64pad;
      } else {
        output += tab.charAt(triplet >>> 6 * (3 - j) & 0x3F);
      }
    }
  }
  return output;
}

Hashes = {
  /**
   * @property {String} version
   * @readonly
   */
  VERSION: '1.0.5',
  /**
   * @member Hashes
   * @class Base64
   * @constructor
   */
  Base64: function Base64() {
    // private properties
    var tab = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',
        pad = '=',
        // default pad according with the RFC standard
    url = false,
        // URL encoding support @todo
    utf8 = true; // by default enable UTF-8 support encoding

    // public method for encoding
    this.encode = function (input) {
      var i,
          j,
          triplet,
          output = '',
          len = input.length;

      pad = pad || '=';
      input = utf8 ? utf8Encode(input) : input;

      for (i = 0; i < len; i += 3) {
        triplet = input.charCodeAt(i) << 16 | (i + 1 < len ? input.charCodeAt(i + 1) << 8 : 0) | (i + 2 < len ? input.charCodeAt(i + 2) : 0);
        for (j = 0; j < 4; j += 1) {
          if (i * 8 + j * 6 > len * 8) {
            output += pad;
          } else {
            output += tab.charAt(triplet >>> 6 * (3 - j) & 0x3F);
          }
        }
      }
      return output;
    };

    // public method for decoding
    this.decode = function (input) {
      // var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
      var i,
          o1,
          o2,
          o3,
          h1,
          h2,
          h3,
          h4,
          bits,
          ac,
          dec = '',
          arr = [];
      if (!input) {
        return input;
      }

      i = ac = 0;
      input = input.replace(new RegExp('\\' + pad, 'gi'), ''); // use '='
      //input += '';

      do {
        // unpack four hexets into three octets using index points in b64
        h1 = tab.indexOf(input.charAt(i += 1));
        h2 = tab.indexOf(input.charAt(i += 1));
        h3 = tab.indexOf(input.charAt(i += 1));
        h4 = tab.indexOf(input.charAt(i += 1));

        bits = h1 << 18 | h2 << 12 | h3 << 6 | h4;

        o1 = bits >> 16 & 0xff;
        o2 = bits >> 8 & 0xff;
        o3 = bits & 0xff;
        ac += 1;

        if (h3 === 64) {
          arr[ac] = String.fromCharCode(o1);
        } else if (h4 === 64) {
          arr[ac] = String.fromCharCode(o1, o2);
        } else {
          arr[ac] = String.fromCharCode(o1, o2, o3);
        }
      } while (i < input.length);

      dec = arr.join('');
      dec = utf8 ? utf8Decode(dec) : dec;

      return dec;
    };

    // set custom pad string
    this.setPad = function (str) {
      pad = str || pad;
      return this;
    };
    // set custom tab string characters
    this.setTab = function (str) {
      tab = str || tab;
      return this;
    };
    this.setUTF8 = function (bool) {
      if (typeof bool === 'boolean') {
        utf8 = bool;
      }
      return this;
    };
  },

  /**
   * CRC-32 calculation
   * @member Hashes
   * @method CRC32
   * @static
   * @param {String} str Input String
   * @return {String}
   */
  CRC32: function CRC32(str) {
    var crc = 0,
        x = 0,
        y = 0,
        table,
        i,
        iTop;
    str = utf8Encode(str);

    table = ['00000000 77073096 EE0E612C 990951BA 076DC419 706AF48F E963A535 9E6495A3 0EDB8832 ', '79DCB8A4 E0D5E91E 97D2D988 09B64C2B 7EB17CBD E7B82D07 90BF1D91 1DB71064 6AB020F2 F3B97148 ', '84BE41DE 1ADAD47D 6DDDE4EB F4D4B551 83D385C7 136C9856 646BA8C0 FD62F97A 8A65C9EC 14015C4F ', '63066CD9 FA0F3D63 8D080DF5 3B6E20C8 4C69105E D56041E4 A2677172 3C03E4D1 4B04D447 D20D85FD ', 'A50AB56B 35B5A8FA 42B2986C DBBBC9D6 ACBCF940 32D86CE3 45DF5C75 DCD60DCF ABD13D59 26D930AC ', '51DE003A C8D75180 BFD06116 21B4F4B5 56B3C423 CFBA9599 B8BDA50F 2802B89E 5F058808 C60CD9B2 ', 'B10BE924 2F6F7C87 58684C11 C1611DAB B6662D3D 76DC4190 01DB7106 98D220BC EFD5102A 71B18589 ', '06B6B51F 9FBFE4A5 E8B8D433 7807C9A2 0F00F934 9609A88E E10E9818 7F6A0DBB 086D3D2D 91646C97 ', 'E6635C01 6B6B51F4 1C6C6162 856530D8 F262004E 6C0695ED 1B01A57B 8208F4C1 F50FC457 65B0D9C6 ', '12B7E950 8BBEB8EA FCB9887C 62DD1DDF 15DA2D49 8CD37CF3 FBD44C65 4DB26158 3AB551CE A3BC0074 ', 'D4BB30E2 4ADFA541 3DD895D7 A4D1C46D D3D6F4FB 4369E96A 346ED9FC AD678846 DA60B8D0 44042D73 ', '33031DE5 AA0A4C5F DD0D7CC9 5005713C 270241AA BE0B1010 C90C2086 5768B525 206F85B3 B966D409 ', 'CE61E49F 5EDEF90E 29D9C998 B0D09822 C7D7A8B4 59B33D17 2EB40D81 B7BD5C3B C0BA6CAD EDB88320 ', '9ABFB3B6 03B6E20C 74B1D29A EAD54739 9DD277AF 04DB2615 73DC1683 E3630B12 94643B84 0D6D6A3E ', '7A6A5AA8 E40ECF0B 9309FF9D 0A00AE27 7D079EB1 F00F9344 8708A3D2 1E01F268 6906C2FE F762575D ', '806567CB 196C3671 6E6B06E7 FED41B76 89D32BE0 10DA7A5A 67DD4ACC F9B9DF6F 8EBEEFF9 17B7BE43 ', '60B08ED5 D6D6A3E8 A1D1937E 38D8C2C4 4FDFF252 D1BB67F1 A6BC5767 3FB506DD 48B2364B D80D2BDA ', 'AF0A1B4C 36034AF6 41047A60 DF60EFC3 A867DF55 316E8EEF 4669BE79 CB61B38C BC66831A 256FD2A0 ', '5268E236 CC0C7795 BB0B4703 220216B9 5505262F C5BA3BBE B2BD0B28 2BB45A92 5CB36A04 C2D7FFA7 ', 'B5D0CF31 2CD99E8B 5BDEAE1D 9B64C2B0 EC63F226 756AA39C 026D930A 9C0906A9 EB0E363F 72076785 ', '05005713 95BF4A82 E2B87A14 7BB12BAE 0CB61B38 92D28E9B E5D5BE0D 7CDCEFB7 0BDBDF21 86D3D2D4 ', 'F1D4E242 68DDB3F8 1FDA836E 81BE16CD F6B9265B 6FB077E1 18B74777 88085AE6 FF0F6A70 66063BCA ', '11010B5C 8F659EFF F862AE69 616BFFD3 166CCF45 A00AE278 D70DD2EE 4E048354 3903B3C2 A7672661 ', 'D06016F7 4969474D 3E6E77DB AED16A4A D9D65ADC 40DF0B66 37D83BF0 A9BCAE53 DEBB9EC5 47B2CF7F ', '30B5FFE9 BDBDF21C CABAC28A 53B39330 24B4A3A6 BAD03605 CDD70693 54DE5729 23D967BF B3667A2E ', 'C4614AB8 5D681B02 2A6F2B94 B40BBE37 C30C8EA1 5A05DF1B 2D02EF8D'].join('');

    crc = crc ^ -1;
    for (i = 0, iTop = str.length; i < iTop; i += 1) {
      y = (crc ^ str.charCodeAt(i)) & 0xFF;
      x = '0x' + table.substr(y * 9, 8);
      crc = crc >>> 8 ^ x;
    }
    // always return a positive number (that's what >>> 0 does)
    return (crc ^ -1) >>> 0;
  },
  /**
   * @member Hashes
   * @class MD5
   * @constructor
   * @param {Object} [config]
   *
   * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
   * Digest Algorithm, as defined in RFC 1321.
   * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
   * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
   * See <http://pajhome.org.uk/crypt/md5> for more infHashes.
   */
  MD5: function MD5(options) {
    /**
     * Private config properties. You may need to tweak these to be compatible with
     * the server-side, but the defaults work in most cases.
     * See {@link Hashes.MD5#method-setUpperCase} and {@link Hashes.SHA1#method-setUpperCase}
     */
    var hexcase = options && typeof options.uppercase === 'boolean' ? options.uppercase : false,
        // hexadecimal output case format. false - lowercase; true - uppercase
    b64pad = options && typeof options.pad === 'string' ? options.pda : '=',
        // base-64 pad character. Defaults to '=' for strict RFC compliance
    utf8 = options && typeof options.utf8 === 'boolean' ? options.utf8 : true; // enable/disable utf8 encoding

    // privileged (public) methods
    this.hex = function (s) {
      return rstr2hex(rstr(s, utf8), hexcase);
    };
    this.b64 = function (s) {
      return rstr2b64(rstr(s), b64pad);
    };
    this.any = function (s, e) {
      return rstr2any(rstr(s, utf8), e);
    };
    this.raw = function (s) {
      return rstr(s, utf8);
    };
    this.hex_hmac = function (k, d) {
      return rstr2hex(rstr_hmac(k, d), hexcase);
    };
    this.b64_hmac = function (k, d) {
      return rstr2b64(rstr_hmac(k, d), b64pad);
    };
    this.any_hmac = function (k, d, e) {
      return rstr2any(rstr_hmac(k, d), e);
    };
    /**
     * Perform a simple self-test to see if the VM is working
     * @return {String} Hexadecimal hash sample
     */
    this.vm_test = function () {
      return hex('abc').toLowerCase() === '900150983cd24fb0d6963f7d28e17f72';
    };
    /**
     * Enable/disable uppercase hexadecimal returned string
     * @param {Boolean}
     * @return {Object} this
     */
    this.setUpperCase = function (a) {
      if (typeof a === 'boolean') {
        hexcase = a;
      }
      return this;
    };
    /**
     * Defines a base64 pad string
     * @param {String} Pad
     * @return {Object} this
     */
    this.setPad = function (a) {
      b64pad = a || b64pad;
      return this;
    };
    /**
     * Defines a base64 pad string
     * @param {Boolean}
     * @return {Object} [this]
     */
    this.setUTF8 = function (a) {
      if (typeof a === 'boolean') {
        utf8 = a;
      }
      return this;
    };

    // private methods

    /**
     * Calculate the MD5 of a raw string
     */

    function rstr(s) {
      s = utf8 ? utf8Encode(s) : s;
      return binl2rstr(binl(rstr2binl(s), s.length * 8));
    }

    /**
     * Calculate the HMAC-MD5, of a key and some data (raw strings)
     */

    function rstr_hmac(key, data) {
      var bkey, ipad, opad, hash, i;

      key = utf8 ? utf8Encode(key) : key;
      data = utf8 ? utf8Encode(data) : data;
      bkey = rstr2binl(key);
      if (bkey.length > 16) {
        bkey = binl(bkey, key.length * 8);
      }

      ipad = Array(16), opad = Array(16);
      for (i = 0; i < 16; i += 1) {
        ipad[i] = bkey[i] ^ 0x36363636;
        opad[i] = bkey[i] ^ 0x5C5C5C5C;
      }
      hash = binl(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
      return binl2rstr(binl(opad.concat(hash), 512 + 128));
    }

    /**
     * Calculate the MD5 of an array of little-endian words, and a bit length.
     */

    function binl(x, len) {
      var i,
          olda,
          oldb,
          oldc,
          oldd,
          a = 1732584193,
          b = -271733879,
          c = -1732584194,
          d = 271733878;

      /* append padding */
      x[len >> 5] |= 0x80 << len % 32;
      x[(len + 64 >>> 9 << 4) + 14] = len;

      for (i = 0; i < x.length; i += 16) {
        olda = a;
        oldb = b;
        oldc = c;
        oldd = d;

        a = md5_ff(a, b, c, d, x[i + 0], 7, -680876936);
        d = md5_ff(d, a, b, c, x[i + 1], 12, -389564586);
        c = md5_ff(c, d, a, b, x[i + 2], 17, 606105819);
        b = md5_ff(b, c, d, a, x[i + 3], 22, -1044525330);
        a = md5_ff(a, b, c, d, x[i + 4], 7, -176418897);
        d = md5_ff(d, a, b, c, x[i + 5], 12, 1200080426);
        c = md5_ff(c, d, a, b, x[i + 6], 17, -1473231341);
        b = md5_ff(b, c, d, a, x[i + 7], 22, -45705983);
        a = md5_ff(a, b, c, d, x[i + 8], 7, 1770035416);
        d = md5_ff(d, a, b, c, x[i + 9], 12, -1958414417);
        c = md5_ff(c, d, a, b, x[i + 10], 17, -42063);
        b = md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);
        a = md5_ff(a, b, c, d, x[i + 12], 7, 1804603682);
        d = md5_ff(d, a, b, c, x[i + 13], 12, -40341101);
        c = md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);
        b = md5_ff(b, c, d, a, x[i + 15], 22, 1236535329);

        a = md5_gg(a, b, c, d, x[i + 1], 5, -165796510);
        d = md5_gg(d, a, b, c, x[i + 6], 9, -1069501632);
        c = md5_gg(c, d, a, b, x[i + 11], 14, 643717713);
        b = md5_gg(b, c, d, a, x[i + 0], 20, -373897302);
        a = md5_gg(a, b, c, d, x[i + 5], 5, -701558691);
        d = md5_gg(d, a, b, c, x[i + 10], 9, 38016083);
        c = md5_gg(c, d, a, b, x[i + 15], 14, -660478335);
        b = md5_gg(b, c, d, a, x[i + 4], 20, -405537848);
        a = md5_gg(a, b, c, d, x[i + 9], 5, 568446438);
        d = md5_gg(d, a, b, c, x[i + 14], 9, -1019803690);
        c = md5_gg(c, d, a, b, x[i + 3], 14, -187363961);
        b = md5_gg(b, c, d, a, x[i + 8], 20, 1163531501);
        a = md5_gg(a, b, c, d, x[i + 13], 5, -1444681467);
        d = md5_gg(d, a, b, c, x[i + 2], 9, -51403784);
        c = md5_gg(c, d, a, b, x[i + 7], 14, 1735328473);
        b = md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);

        a = md5_hh(a, b, c, d, x[i + 5], 4, -378558);
        d = md5_hh(d, a, b, c, x[i + 8], 11, -2022574463);
        c = md5_hh(c, d, a, b, x[i + 11], 16, 1839030562);
        b = md5_hh(b, c, d, a, x[i + 14], 23, -35309556);
        a = md5_hh(a, b, c, d, x[i + 1], 4, -1530992060);
        d = md5_hh(d, a, b, c, x[i + 4], 11, 1272893353);
        c = md5_hh(c, d, a, b, x[i + 7], 16, -155497632);
        b = md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);
        a = md5_hh(a, b, c, d, x[i + 13], 4, 681279174);
        d = md5_hh(d, a, b, c, x[i + 0], 11, -358537222);
        c = md5_hh(c, d, a, b, x[i + 3], 16, -722521979);
        b = md5_hh(b, c, d, a, x[i + 6], 23, 76029189);
        a = md5_hh(a, b, c, d, x[i + 9], 4, -640364487);
        d = md5_hh(d, a, b, c, x[i + 12], 11, -421815835);
        c = md5_hh(c, d, a, b, x[i + 15], 16, 530742520);
        b = md5_hh(b, c, d, a, x[i + 2], 23, -995338651);

        a = md5_ii(a, b, c, d, x[i + 0], 6, -198630844);
        d = md5_ii(d, a, b, c, x[i + 7], 10, 1126891415);
        c = md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);
        b = md5_ii(b, c, d, a, x[i + 5], 21, -57434055);
        a = md5_ii(a, b, c, d, x[i + 12], 6, 1700485571);
        d = md5_ii(d, a, b, c, x[i + 3], 10, -1894986606);
        c = md5_ii(c, d, a, b, x[i + 10], 15, -1051523);
        b = md5_ii(b, c, d, a, x[i + 1], 21, -2054922799);
        a = md5_ii(a, b, c, d, x[i + 8], 6, 1873313359);
        d = md5_ii(d, a, b, c, x[i + 15], 10, -30611744);
        c = md5_ii(c, d, a, b, x[i + 6], 15, -1560198380);
        b = md5_ii(b, c, d, a, x[i + 13], 21, 1309151649);
        a = md5_ii(a, b, c, d, x[i + 4], 6, -145523070);
        d = md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);
        c = md5_ii(c, d, a, b, x[i + 2], 15, 718787259);
        b = md5_ii(b, c, d, a, x[i + 9], 21, -343485551);

        a = safe_add(a, olda);
        b = safe_add(b, oldb);
        c = safe_add(c, oldc);
        d = safe_add(d, oldd);
      }
      return Array(a, b, c, d);
    }

    /**
     * These functions implement the four basic operations the algorithm uses.
     */

    function md5_cmn(q, a, b, x, s, t) {
      return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s), b);
    }

    function md5_ff(a, b, c, d, x, s, t) {
      return md5_cmn(b & c | ~b & d, a, b, x, s, t);
    }

    function md5_gg(a, b, c, d, x, s, t) {
      return md5_cmn(b & d | c & ~d, a, b, x, s, t);
    }

    function md5_hh(a, b, c, d, x, s, t) {
      return md5_cmn(b ^ c ^ d, a, b, x, s, t);
    }

    function md5_ii(a, b, c, d, x, s, t) {
      return md5_cmn(c ^ (b | ~d), a, b, x, s, t);
    }
  },
  /**
   * @member Hashes
   * @class Hashes.SHA1
   * @param {Object} [config]
   * @constructor
   *
   * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined in FIPS 180-1
   * Version 2.2 Copyright Paul Johnston 2000 - 2009.
   * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
   * See http://pajhome.org.uk/crypt/md5 for details.
   */
  SHA1: function SHA1(options) {
    /**
     * Private config properties. You may need to tweak these to be compatible with
     * the server-side, but the defaults work in most cases.
     * See {@link Hashes.MD5#method-setUpperCase} and {@link Hashes.SHA1#method-setUpperCase}
     */
    var hexcase = options && typeof options.uppercase === 'boolean' ? options.uppercase : false,
        // hexadecimal output case format. false - lowercase; true - uppercase
    b64pad = options && typeof options.pad === 'string' ? options.pda : '=',
        // base-64 pad character. Defaults to '=' for strict RFC compliance
    utf8 = options && typeof options.utf8 === 'boolean' ? options.utf8 : true; // enable/disable utf8 encoding

    // public methods
    this.hex = function (s) {
      return rstr2hex(rstr(s, utf8), hexcase);
    };
    this.b64 = function (s) {
      return rstr2b64(rstr(s, utf8), b64pad);
    };
    this.any = function (s, e) {
      return rstr2any(rstr(s, utf8), e);
    };
    this.raw = function (s) {
      return rstr(s, utf8);
    };
    this.hex_hmac = function (k, d) {
      return rstr2hex(rstr_hmac(k, d));
    };
    this.b64_hmac = function (k, d) {
      return rstr2b64(rstr_hmac(k, d), b64pad);
    };
    this.any_hmac = function (k, d, e) {
      return rstr2any(rstr_hmac(k, d), e);
    };
    /**
     * Perform a simple self-test to see if the VM is working
     * @return {String} Hexadecimal hash sample
     * @public
     */
    this.vm_test = function () {
      return hex('abc').toLowerCase() === '900150983cd24fb0d6963f7d28e17f72';
    };
    /**
     * @description Enable/disable uppercase hexadecimal returned string
     * @param {boolean}
     * @return {Object} this
     * @public
     */
    this.setUpperCase = function (a) {
      if (typeof a === 'boolean') {
        hexcase = a;
      }
      return this;
    };
    /**
     * @description Defines a base64 pad string
     * @param {string} Pad
     * @return {Object} this
     * @public
     */
    this.setPad = function (a) {
      b64pad = a || b64pad;
      return this;
    };
    /**
     * @description Defines a base64 pad string
     * @param {boolean}
     * @return {Object} this
     * @public
     */
    this.setUTF8 = function (a) {
      if (typeof a === 'boolean') {
        utf8 = a;
      }
      return this;
    };

    // private methods

    /**
     * Calculate the SHA-512 of a raw string
     */

    function rstr(s) {
      s = utf8 ? utf8Encode(s) : s;
      return binb2rstr(binb(rstr2binb(s), s.length * 8));
    }

    /**
     * Calculate the HMAC-SHA1 of a key and some data (raw strings)
     */

    function rstr_hmac(key, data) {
      var bkey, ipad, opad, i, hash;
      key = utf8 ? utf8Encode(key) : key;
      data = utf8 ? utf8Encode(data) : data;
      bkey = rstr2binb(key);

      if (bkey.length > 16) {
        bkey = binb(bkey, key.length * 8);
      }
      ipad = Array(16), opad = Array(16);
      for (i = 0; i < 16; i += 1) {
        ipad[i] = bkey[i] ^ 0x36363636;
        opad[i] = bkey[i] ^ 0x5C5C5C5C;
      }
      hash = binb(ipad.concat(rstr2binb(data)), 512 + data.length * 8);
      return binb2rstr(binb(opad.concat(hash), 512 + 160));
    }

    /**
     * Calculate the SHA-1 of an array of big-endian words, and a bit length
     */

    function binb(x, len) {
      var i,
          j,
          t,
          olda,
          oldb,
          oldc,
          oldd,
          olde,
          w = Array(80),
          a = 1732584193,
          b = -271733879,
          c = -1732584194,
          d = 271733878,
          e = -1009589776;

      /* append padding */
      x[len >> 5] |= 0x80 << 24 - len % 32;
      x[(len + 64 >> 9 << 4) + 15] = len;

      for (i = 0; i < x.length; i += 16) {
        olda = a, oldb = b;
        oldc = c;
        oldd = d;
        olde = e;

        for (j = 0; j < 80; j += 1) {
          if (j < 16) {
            w[j] = x[i + j];
          } else {
            w[j] = bit_rol(w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16], 1);
          }
          t = safe_add(safe_add(bit_rol(a, 5), sha1_ft(j, b, c, d)), safe_add(safe_add(e, w[j]), sha1_kt(j)));
          e = d;
          d = c;
          c = bit_rol(b, 30);
          b = a;
          a = t;
        }

        a = safe_add(a, olda);
        b = safe_add(b, oldb);
        c = safe_add(c, oldc);
        d = safe_add(d, oldd);
        e = safe_add(e, olde);
      }
      return Array(a, b, c, d, e);
    }

    /**
     * Perform the appropriate triplet combination function for the current
     * iteration
     */

    function sha1_ft(t, b, c, d) {
      if (t < 20) {
        return b & c | ~b & d;
      }
      if (t < 40) {
        return b ^ c ^ d;
      }
      if (t < 60) {
        return b & c | b & d | c & d;
      }
      return b ^ c ^ d;
    }

    /**
     * Determine the appropriate additive constant for the current iteration
     */

    function sha1_kt(t) {
      return t < 20 ? 1518500249 : t < 40 ? 1859775393 : t < 60 ? -1894007588 : -899497514;
    }
  },
  /**
   * @class Hashes.SHA256
   * @param {config}
   *
   * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined in FIPS 180-2
   * Version 2.2 Copyright Angel Marin, Paul Johnston 2000 - 2009.
   * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
   * See http://pajhome.org.uk/crypt/md5 for details.
   * Also http://anmar.eu.org/projects/jssha2/
   */
  SHA256: function SHA256(options) {
    /**
     * Private properties configuration variables. You may need to tweak these to be compatible with
     * the server-side, but the defaults work in most cases.
     * @see this.setUpperCase() method
     * @see this.setPad() method
     */
    var hexcase = options && typeof options.uppercase === 'boolean' ? options.uppercase : false,
        // hexadecimal output case format. false - lowercase; true - uppercase  */
    b64pad = options && typeof options.pad === 'string' ? options.pda : '=',

    /* base-64 pad character. Default '=' for strict RFC compliance   */
    utf8 = options && typeof options.utf8 === 'boolean' ? options.utf8 : true,

    /* enable/disable utf8 encoding */
    sha256_K;

    /* privileged (public) methods */
    this.hex = function (s) {
      return rstr2hex(rstr(s, utf8));
    };
    this.b64 = function (s) {
      return rstr2b64(rstr(s, utf8), b64pad);
    };
    this.any = function (s, e) {
      return rstr2any(rstr(s, utf8), e);
    };
    this.raw = function (s) {
      return rstr(s, utf8);
    };
    this.hex_hmac = function (k, d) {
      return rstr2hex(rstr_hmac(k, d));
    };
    this.b64_hmac = function (k, d) {
      return rstr2b64(rstr_hmac(k, d), b64pad);
    };
    this.any_hmac = function (k, d, e) {
      return rstr2any(rstr_hmac(k, d), e);
    };
    /**
     * Perform a simple self-test to see if the VM is working
     * @return {String} Hexadecimal hash sample
     * @public
     */
    this.vm_test = function () {
      return hex('abc').toLowerCase() === '900150983cd24fb0d6963f7d28e17f72';
    };
    /**
     * Enable/disable uppercase hexadecimal returned string
     * @param {boolean}
     * @return {Object} this
     * @public
     */
    this.setUpperCase = function (a) {
      if (typeof a === 'boolean') {
        hexcase = a;
      }
      return this;
    };
    /**
     * @description Defines a base64 pad string
     * @param {string} Pad
     * @return {Object} this
     * @public
     */
    this.setPad = function (a) {
      b64pad = a || b64pad;
      return this;
    };
    /**
     * Defines a base64 pad string
     * @param {boolean}
     * @return {Object} this
     * @public
     */
    this.setUTF8 = function (a) {
      if (typeof a === 'boolean') {
        utf8 = a;
      }
      return this;
    };

    // private methods

    /**
     * Calculate the SHA-512 of a raw string
     */

    function rstr(s, utf8) {
      s = utf8 ? utf8Encode(s) : s;
      return binb2rstr(binb(rstr2binb(s), s.length * 8));
    }

    /**
     * Calculate the HMAC-sha256 of a key and some data (raw strings)
     */

    function rstr_hmac(key, data) {
      key = utf8 ? utf8Encode(key) : key;
      data = utf8 ? utf8Encode(data) : data;
      var hash,
          i = 0,
          bkey = rstr2binb(key),
          ipad = Array(16),
          opad = Array(16);

      if (bkey.length > 16) {
        bkey = binb(bkey, key.length * 8);
      }

      for (; i < 16; i += 1) {
        ipad[i] = bkey[i] ^ 0x36363636;
        opad[i] = bkey[i] ^ 0x5C5C5C5C;
      }

      hash = binb(ipad.concat(rstr2binb(data)), 512 + data.length * 8);
      return binb2rstr(binb(opad.concat(hash), 512 + 256));
    }

    /*
     * Main sha256 function, with its support functions
     */

    function sha256_S(X, n) {
      return X >>> n | X << 32 - n;
    }

    function sha256_R(X, n) {
      return X >>> n;
    }

    function sha256_Ch(x, y, z) {
      return x & y ^ ~x & z;
    }

    function sha256_Maj(x, y, z) {
      return x & y ^ x & z ^ y & z;
    }

    function sha256_Sigma0256(x) {
      return sha256_S(x, 2) ^ sha256_S(x, 13) ^ sha256_S(x, 22);
    }

    function sha256_Sigma1256(x) {
      return sha256_S(x, 6) ^ sha256_S(x, 11) ^ sha256_S(x, 25);
    }

    function sha256_Gamma0256(x) {
      return sha256_S(x, 7) ^ sha256_S(x, 18) ^ sha256_R(x, 3);
    }

    function sha256_Gamma1256(x) {
      return sha256_S(x, 17) ^ sha256_S(x, 19) ^ sha256_R(x, 10);
    }

    function sha256_Sigma0512(x) {
      return sha256_S(x, 28) ^ sha256_S(x, 34) ^ sha256_S(x, 39);
    }

    function sha256_Sigma1512(x) {
      return sha256_S(x, 14) ^ sha256_S(x, 18) ^ sha256_S(x, 41);
    }

    function sha256_Gamma0512(x) {
      return sha256_S(x, 1) ^ sha256_S(x, 8) ^ sha256_R(x, 7);
    }

    function sha256_Gamma1512(x) {
      return sha256_S(x, 19) ^ sha256_S(x, 61) ^ sha256_R(x, 6);
    }

    sha256_K = [1116352408, 1899447441, -1245643825, -373957723, 961987163, 1508970993, -1841331548, -1424204075, -670586216, 310598401, 607225278, 1426881987, 1925078388, -2132889090, -1680079193, -1046744716, -459576895, -272742522, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, -1740746414, -1473132947, -1341970488, -1084653625, -958395405, -710438585, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, -2117940946, -1838011259, -1564481375, -1474664885, -1035236496, -949202525, -778901479, -694614492, -200395387, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, -2067236844, -1933114872, -1866530822, -1538233109, -1090935817, -965641998];

    function binb(m, l) {
      var HASH = [1779033703, -1150833019, 1013904242, -1521486534, 1359893119, -1694144372, 528734635, 1541459225];
      var W = new Array(64);
      var a, b, c, d, e, f, g, h;
      var i, j, T1, T2;

      /* append padding */
      m[l >> 5] |= 0x80 << 24 - l % 32;
      m[(l + 64 >> 9 << 4) + 15] = l;

      for (i = 0; i < m.length; i += 16) {
        a = HASH[0];
        b = HASH[1];
        c = HASH[2];
        d = HASH[3];
        e = HASH[4];
        f = HASH[5];
        g = HASH[6];
        h = HASH[7];

        for (j = 0; j < 64; j += 1) {
          if (j < 16) {
            W[j] = m[j + i];
          } else {
            W[j] = safe_add(safe_add(safe_add(sha256_Gamma1256(W[j - 2]), W[j - 7]), sha256_Gamma0256(W[j - 15])), W[j - 16]);
          }

          T1 = safe_add(safe_add(safe_add(safe_add(h, sha256_Sigma1256(e)), sha256_Ch(e, f, g)), sha256_K[j]), W[j]);
          T2 = safe_add(sha256_Sigma0256(a), sha256_Maj(a, b, c));
          h = g;
          g = f;
          f = e;
          e = safe_add(d, T1);
          d = c;
          c = b;
          b = a;
          a = safe_add(T1, T2);
        }

        HASH[0] = safe_add(a, HASH[0]);
        HASH[1] = safe_add(b, HASH[1]);
        HASH[2] = safe_add(c, HASH[2]);
        HASH[3] = safe_add(d, HASH[3]);
        HASH[4] = safe_add(e, HASH[4]);
        HASH[5] = safe_add(f, HASH[5]);
        HASH[6] = safe_add(g, HASH[6]);
        HASH[7] = safe_add(h, HASH[7]);
      }
      return HASH;
    }
  },

  /**
   * @class Hashes.SHA512
   * @param {config}
   *
   * A JavaScript implementation of the Secure Hash Algorithm, SHA-512, as defined in FIPS 180-2
   * Version 2.2 Copyright Anonymous Contributor, Paul Johnston 2000 - 2009.
   * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
   * See http://pajhome.org.uk/crypt/md5 for details.
   */
  SHA512: function SHA512(options) {
    /**
     * Private properties configuration variables. You may need to tweak these to be compatible with
     * the server-side, but the defaults work in most cases.
     * @see this.setUpperCase() method
     * @see this.setPad() method
     */
    var hexcase = options && typeof options.uppercase === 'boolean' ? options.uppercase : false,

    /* hexadecimal output case format. false - lowercase; true - uppercase  */
    b64pad = options && typeof options.pad === 'string' ? options.pda : '=',

    /* base-64 pad character. Default '=' for strict RFC compliance   */
    utf8 = options && typeof options.utf8 === 'boolean' ? options.utf8 : true,

    /* enable/disable utf8 encoding */
    sha512_k;

    /* privileged (public) methods */
    this.hex = function (s) {
      return rstr2hex(rstr(s));
    };
    this.b64 = function (s) {
      return rstr2b64(rstr(s), b64pad);
    };
    this.any = function (s, e) {
      return rstr2any(rstr(s), e);
    };
    this.raw = function (s) {
      return rstr(s, utf8);
    };
    this.hex_hmac = function (k, d) {
      return rstr2hex(rstr_hmac(k, d));
    };
    this.b64_hmac = function (k, d) {
      return rstr2b64(rstr_hmac(k, d), b64pad);
    };
    this.any_hmac = function (k, d, e) {
      return rstr2any(rstr_hmac(k, d), e);
    };
    /**
     * Perform a simple self-test to see if the VM is working
     * @return {String} Hexadecimal hash sample
     * @public
     */
    this.vm_test = function () {
      return hex('abc').toLowerCase() === '900150983cd24fb0d6963f7d28e17f72';
    };
    /**
     * @description Enable/disable uppercase hexadecimal returned string
     * @param {boolean}
     * @return {Object} this
     * @public
     */
    this.setUpperCase = function (a) {
      if (typeof a === 'boolean') {
        hexcase = a;
      }
      return this;
    };
    /**
     * @description Defines a base64 pad string
     * @param {string} Pad
     * @return {Object} this
     * @public
     */
    this.setPad = function (a) {
      b64pad = a || b64pad;
      return this;
    };
    /**
     * @description Defines a base64 pad string
     * @param {boolean}
     * @return {Object} this
     * @public
     */
    this.setUTF8 = function (a) {
      if (typeof a === 'boolean') {
        utf8 = a;
      }
      return this;
    };

    /* private methods */

    /**
     * Calculate the SHA-512 of a raw string
     */

    function rstr(s) {
      s = utf8 ? utf8Encode(s) : s;
      return binb2rstr(binb(rstr2binb(s), s.length * 8));
    }
    /*
     * Calculate the HMAC-SHA-512 of a key and some data (raw strings)
     */

    function rstr_hmac(key, data) {
      key = utf8 ? utf8Encode(key) : key;
      data = utf8 ? utf8Encode(data) : data;

      var hash,
          i = 0,
          bkey = rstr2binb(key),
          ipad = Array(32),
          opad = Array(32);

      if (bkey.length > 32) {
        bkey = binb(bkey, key.length * 8);
      }

      for (; i < 32; i += 1) {
        ipad[i] = bkey[i] ^ 0x36363636;
        opad[i] = bkey[i] ^ 0x5C5C5C5C;
      }

      hash = binb(ipad.concat(rstr2binb(data)), 1024 + data.length * 8);
      return binb2rstr(binb(opad.concat(hash), 1024 + 512));
    }

    /**
     * Calculate the SHA-512 of an array of big-endian dwords, and a bit length
     */

    function binb(x, len) {
      var j,
          i,
          l,
          W = new Array(80),
          hash = new Array(16),

      //Initial hash values
      H = [new int64(0x6a09e667, -205731576), new int64(-1150833019, -2067093701), new int64(0x3c6ef372, -23791573), new int64(-1521486534, 0x5f1d36f1), new int64(0x510e527f, -1377402159), new int64(-1694144372, 0x2b3e6c1f), new int64(0x1f83d9ab, -79577749), new int64(0x5be0cd19, 0x137e2179)],
          T1 = new int64(0, 0),
          T2 = new int64(0, 0),
          a = new int64(0, 0),
          b = new int64(0, 0),
          c = new int64(0, 0),
          d = new int64(0, 0),
          e = new int64(0, 0),
          f = new int64(0, 0),
          g = new int64(0, 0),
          h = new int64(0, 0),

      //Temporary variables not specified by the document
      s0 = new int64(0, 0),
          s1 = new int64(0, 0),
          Ch = new int64(0, 0),
          Maj = new int64(0, 0),
          r1 = new int64(0, 0),
          r2 = new int64(0, 0),
          r3 = new int64(0, 0);

      if (sha512_k === undefined) {
        //SHA512 constants
        sha512_k = [new int64(0x428a2f98, -685199838), new int64(0x71374491, 0x23ef65cd), new int64(-1245643825, -330482897), new int64(-373957723, -2121671748), new int64(0x3956c25b, -213338824), new int64(0x59f111f1, -1241133031), new int64(-1841331548, -1357295717), new int64(-1424204075, -630357736), new int64(-670586216, -1560083902), new int64(0x12835b01, 0x45706fbe), new int64(0x243185be, 0x4ee4b28c), new int64(0x550c7dc3, -704662302), new int64(0x72be5d74, -226784913), new int64(-2132889090, 0x3b1696b1), new int64(-1680079193, 0x25c71235), new int64(-1046744716, -815192428), new int64(-459576895, -1628353838), new int64(-272742522, 0x384f25e3), new int64(0xfc19dc6, -1953704523), new int64(0x240ca1cc, 0x77ac9c65), new int64(0x2de92c6f, 0x592b0275), new int64(0x4a7484aa, 0x6ea6e483), new int64(0x5cb0a9dc, -1119749164), new int64(0x76f988da, -2096016459), new int64(-1740746414, -295247957), new int64(-1473132947, 0x2db43210), new int64(-1341970488, -1728372417), new int64(-1084653625, -1091629340), new int64(-958395405, 0x3da88fc2), new int64(-710438585, -1828018395), new int64(0x6ca6351, -536640913), new int64(0x14292967, 0xa0e6e70), new int64(0x27b70a85, 0x46d22ffc), new int64(0x2e1b2138, 0x5c26c926), new int64(0x4d2c6dfc, 0x5ac42aed), new int64(0x53380d13, -1651133473), new int64(0x650a7354, -1951439906), new int64(0x766a0abb, 0x3c77b2a8), new int64(-2117940946, 0x47edaee6), new int64(-1838011259, 0x1482353b), new int64(-1564481375, 0x4cf10364), new int64(-1474664885, -1136513023), new int64(-1035236496, -789014639), new int64(-949202525, 0x654be30), new int64(-778901479, -688958952), new int64(-694614492, 0x5565a910), new int64(-200395387, 0x5771202a), new int64(0x106aa070, 0x32bbd1b8), new int64(0x19a4c116, -1194143544), new int64(0x1e376c08, 0x5141ab53), new int64(0x2748774c, -544281703), new int64(0x34b0bcb5, -509917016), new int64(0x391c0cb3, -976659869), new int64(0x4ed8aa4a, -482243893), new int64(0x5b9cca4f, 0x7763e373), new int64(0x682e6ff3, -692930397), new int64(0x748f82ee, 0x5defb2fc), new int64(0x78a5636f, 0x43172f60), new int64(-2067236844, -1578062990), new int64(-1933114872, 0x1a6439ec), new int64(-1866530822, 0x23631e28), new int64(-1538233109, -561857047), new int64(-1090935817, -1295615723), new int64(-965641998, -479046869), new int64(-903397682, -366583396), new int64(-779700025, 0x21c0c207), new int64(-354779690, -840897762), new int64(-176337025, -294727304), new int64(0x6f067aa, 0x72176fba), new int64(0xa637dc5, -1563912026), new int64(0x113f9804, -1090974290), new int64(0x1b710b35, 0x131c471b), new int64(0x28db77f5, 0x23047d84), new int64(0x32caab7b, 0x40c72493), new int64(0x3c9ebe0a, 0x15c9bebc), new int64(0x431d67c4, -1676669620), new int64(0x4cc5d4be, -885112138), new int64(0x597f299c, -60457430), new int64(0x5fcb6fab, 0x3ad6faec), new int64(0x6c44198c, 0x4a475817)];
      }

      for (i = 0; i < 80; i += 1) {
        W[i] = new int64(0, 0);
      }

      // append padding to the source string. The format is described in the FIPS.
      x[len >> 5] |= 0x80 << 24 - (len & 0x1f);
      x[(len + 128 >> 10 << 5) + 31] = len;
      l = x.length;
      for (i = 0; i < l; i += 32) {
        //32 dwords is the block size
        int64copy(a, H[0]);
        int64copy(b, H[1]);
        int64copy(c, H[2]);
        int64copy(d, H[3]);
        int64copy(e, H[4]);
        int64copy(f, H[5]);
        int64copy(g, H[6]);
        int64copy(h, H[7]);

        for (j = 0; j < 16; j += 1) {
          W[j].h = x[i + 2 * j];
          W[j].l = x[i + 2 * j + 1];
        }

        for (j = 16; j < 80; j += 1) {
          //sigma1
          int64rrot(r1, W[j - 2], 19);
          int64revrrot(r2, W[j - 2], 29);
          int64shr(r3, W[j - 2], 6);
          s1.l = r1.l ^ r2.l ^ r3.l;
          s1.h = r1.h ^ r2.h ^ r3.h;
          //sigma0
          int64rrot(r1, W[j - 15], 1);
          int64rrot(r2, W[j - 15], 8);
          int64shr(r3, W[j - 15], 7);
          s0.l = r1.l ^ r2.l ^ r3.l;
          s0.h = r1.h ^ r2.h ^ r3.h;

          int64add4(W[j], s1, W[j - 7], s0, W[j - 16]);
        }

        for (j = 0; j < 80; j += 1) {
          //Ch
          Ch.l = e.l & f.l ^ ~e.l & g.l;
          Ch.h = e.h & f.h ^ ~e.h & g.h;

          //Sigma1
          int64rrot(r1, e, 14);
          int64rrot(r2, e, 18);
          int64revrrot(r3, e, 9);
          s1.l = r1.l ^ r2.l ^ r3.l;
          s1.h = r1.h ^ r2.h ^ r3.h;

          //Sigma0
          int64rrot(r1, a, 28);
          int64revrrot(r2, a, 2);
          int64revrrot(r3, a, 7);
          s0.l = r1.l ^ r2.l ^ r3.l;
          s0.h = r1.h ^ r2.h ^ r3.h;

          //Maj
          Maj.l = a.l & b.l ^ a.l & c.l ^ b.l & c.l;
          Maj.h = a.h & b.h ^ a.h & c.h ^ b.h & c.h;

          int64add5(T1, h, s1, Ch, sha512_k[j], W[j]);
          int64add(T2, s0, Maj);

          int64copy(h, g);
          int64copy(g, f);
          int64copy(f, e);
          int64add(e, d, T1);
          int64copy(d, c);
          int64copy(c, b);
          int64copy(b, a);
          int64add(a, T1, T2);
        }
        int64add(H[0], H[0], a);
        int64add(H[1], H[1], b);
        int64add(H[2], H[2], c);
        int64add(H[3], H[3], d);
        int64add(H[4], H[4], e);
        int64add(H[5], H[5], f);
        int64add(H[6], H[6], g);
        int64add(H[7], H[7], h);
      }

      //represent the hash as an array of 32-bit dwords
      for (i = 0; i < 8; i += 1) {
        hash[2 * i] = H[i].h;
        hash[2 * i + 1] = H[i].l;
      }
      return hash;
    }

    //A constructor for 64-bit numbers

    function int64(h, l) {
      this.h = h;
      this.l = l;
      //this.toString = int64toString;
    }

    //Copies src into dst, assuming both are 64-bit numbers

    function int64copy(dst, src) {
      dst.h = src.h;
      dst.l = src.l;
    }

    //Right-rotates a 64-bit number by shift
    //Won't handle cases of shift>=32
    //The function revrrot() is for that

    function int64rrot(dst, x, shift) {
      dst.l = x.l >>> shift | x.h << 32 - shift;
      dst.h = x.h >>> shift | x.l << 32 - shift;
    }

    //Reverses the dwords of the source and then rotates right by shift.
    //This is equivalent to rotation by 32+shift

    function int64revrrot(dst, x, shift) {
      dst.l = x.h >>> shift | x.l << 32 - shift;
      dst.h = x.l >>> shift | x.h << 32 - shift;
    }

    //Bitwise-shifts right a 64-bit number by shift
    //Won't handle shift>=32, but it's never needed in SHA512

    function int64shr(dst, x, shift) {
      dst.l = x.l >>> shift | x.h << 32 - shift;
      dst.h = x.h >>> shift;
    }

    //Adds two 64-bit numbers
    //Like the original implementation, does not rely on 32-bit operations

    function int64add(dst, x, y) {
      var w0 = (x.l & 0xffff) + (y.l & 0xffff);
      var w1 = (x.l >>> 16) + (y.l >>> 16) + (w0 >>> 16);
      var w2 = (x.h & 0xffff) + (y.h & 0xffff) + (w1 >>> 16);
      var w3 = (x.h >>> 16) + (y.h >>> 16) + (w2 >>> 16);
      dst.l = w0 & 0xffff | w1 << 16;
      dst.h = w2 & 0xffff | w3 << 16;
    }

    //Same, except with 4 addends. Works faster than adding them one by one.

    function int64add4(dst, a, b, c, d) {
      var w0 = (a.l & 0xffff) + (b.l & 0xffff) + (c.l & 0xffff) + (d.l & 0xffff);
      var w1 = (a.l >>> 16) + (b.l >>> 16) + (c.l >>> 16) + (d.l >>> 16) + (w0 >>> 16);
      var w2 = (a.h & 0xffff) + (b.h & 0xffff) + (c.h & 0xffff) + (d.h & 0xffff) + (w1 >>> 16);
      var w3 = (a.h >>> 16) + (b.h >>> 16) + (c.h >>> 16) + (d.h >>> 16) + (w2 >>> 16);
      dst.l = w0 & 0xffff | w1 << 16;
      dst.h = w2 & 0xffff | w3 << 16;
    }

    //Same, except with 5 addends

    function int64add5(dst, a, b, c, d, e) {
      var w0 = (a.l & 0xffff) + (b.l & 0xffff) + (c.l & 0xffff) + (d.l & 0xffff) + (e.l & 0xffff),
          w1 = (a.l >>> 16) + (b.l >>> 16) + (c.l >>> 16) + (d.l >>> 16) + (e.l >>> 16) + (w0 >>> 16),
          w2 = (a.h & 0xffff) + (b.h & 0xffff) + (c.h & 0xffff) + (d.h & 0xffff) + (e.h & 0xffff) + (w1 >>> 16),
          w3 = (a.h >>> 16) + (b.h >>> 16) + (c.h >>> 16) + (d.h >>> 16) + (e.h >>> 16) + (w2 >>> 16);
      dst.l = w0 & 0xffff | w1 << 16;
      dst.h = w2 & 0xffff | w3 << 16;
    }
  },
  /**
   * @class Hashes.RMD160
   * @constructor
   * @param {Object} [config]
   *
   * A JavaScript implementation of the RIPEMD-160 Algorithm
   * Version 2.2 Copyright Jeremy Lin, Paul Johnston 2000 - 2009.
   * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
   * See http://pajhome.org.uk/crypt/md5 for details.
   * Also http://www.ocf.berkeley.edu/~jjlin/jsotp/
   */
  RMD160: function RMD160(options) {
    /**
     * Private properties configuration variables. You may need to tweak these to be compatible with
     * the server-side, but the defaults work in most cases.
     * @see this.setUpperCase() method
     * @see this.setPad() method
     */
    var hexcase = options && typeof options.uppercase === 'boolean' ? options.uppercase : false,

    /* hexadecimal output case format. false - lowercase; true - uppercase  */
    b64pad = options && typeof options.pad === 'string' ? options.pda : '=',

    /* base-64 pad character. Default '=' for strict RFC compliance   */
    utf8 = options && typeof options.utf8 === 'boolean' ? options.utf8 : true,

    /* enable/disable utf8 encoding */
    rmd160_r1 = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13],
        rmd160_r2 = [5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11],
        rmd160_s1 = [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6],
        rmd160_s2 = [8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11];

    /* privileged (public) methods */
    this.hex = function (s) {
      return rstr2hex(rstr(s, utf8));
    };
    this.b64 = function (s) {
      return rstr2b64(rstr(s, utf8), b64pad);
    };
    this.any = function (s, e) {
      return rstr2any(rstr(s, utf8), e);
    };
    this.raw = function (s) {
      return rstr(s, utf8);
    };
    this.hex_hmac = function (k, d) {
      return rstr2hex(rstr_hmac(k, d));
    };
    this.b64_hmac = function (k, d) {
      return rstr2b64(rstr_hmac(k, d), b64pad);
    };
    this.any_hmac = function (k, d, e) {
      return rstr2any(rstr_hmac(k, d), e);
    };
    /**
     * Perform a simple self-test to see if the VM is working
     * @return {String} Hexadecimal hash sample
     * @public
     */
    this.vm_test = function () {
      return hex('abc').toLowerCase() === '900150983cd24fb0d6963f7d28e17f72';
    };
    /**
     * @description Enable/disable uppercase hexadecimal returned string
     * @param {boolean}
     * @return {Object} this
     * @public
     */
    this.setUpperCase = function (a) {
      if (typeof a === 'boolean') {
        hexcase = a;
      }
      return this;
    };
    /**
     * @description Defines a base64 pad string
     * @param {string} Pad
     * @return {Object} this
     * @public
     */
    this.setPad = function (a) {
      if (typeof a !== 'undefined') {
        b64pad = a;
      }
      return this;
    };
    /**
     * @description Defines a base64 pad string
     * @param {boolean}
     * @return {Object} this
     * @public
     */
    this.setUTF8 = function (a) {
      if (typeof a === 'boolean') {
        utf8 = a;
      }
      return this;
    };

    /* private methods */

    /**
     * Calculate the rmd160 of a raw string
     */

    function rstr(s) {
      s = utf8 ? utf8Encode(s) : s;
      return binl2rstr(binl(rstr2binl(s), s.length * 8));
    }

    /**
     * Calculate the HMAC-rmd160 of a key and some data (raw strings)
     */

    function rstr_hmac(key, data) {
      key = utf8 ? utf8Encode(key) : key;
      data = utf8 ? utf8Encode(data) : data;
      var i,
          hash,
          bkey = rstr2binl(key),
          ipad = Array(16),
          opad = Array(16);

      if (bkey.length > 16) {
        bkey = binl(bkey, key.length * 8);
      }

      for (i = 0; i < 16; i += 1) {
        ipad[i] = bkey[i] ^ 0x36363636;
        opad[i] = bkey[i] ^ 0x5C5C5C5C;
      }
      hash = binl(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
      return binl2rstr(binl(opad.concat(hash), 512 + 160));
    }

    /**
     * Convert an array of little-endian words to a string
     */

    function binl2rstr(input) {
      var i,
          output = '',
          l = input.length * 32;
      for (i = 0; i < l; i += 8) {
        output += String.fromCharCode(input[i >> 5] >>> i % 32 & 0xFF);
      }
      return output;
    }

    /**
     * Calculate the RIPE-MD160 of an array of little-endian words, and a bit length.
     */

    function binl(x, len) {
      var T,
          j,
          i,
          l,
          h0 = 0x67452301,
          h1 = 0xefcdab89,
          h2 = 0x98badcfe,
          h3 = 0x10325476,
          h4 = 0xc3d2e1f0,
          A1,
          B1,
          C1,
          D1,
          E1,
          A2,
          B2,
          C2,
          D2,
          E2;

      /* append padding */
      x[len >> 5] |= 0x80 << len % 32;
      x[(len + 64 >>> 9 << 4) + 14] = len;
      l = x.length;

      for (i = 0; i < l; i += 16) {
        A1 = A2 = h0;
        B1 = B2 = h1;
        C1 = C2 = h2;
        D1 = D2 = h3;
        E1 = E2 = h4;
        for (j = 0; j <= 79; j += 1) {
          T = safe_add(A1, rmd160_f(j, B1, C1, D1));
          T = safe_add(T, x[i + rmd160_r1[j]]);
          T = safe_add(T, rmd160_K1(j));
          T = safe_add(bit_rol(T, rmd160_s1[j]), E1);
          A1 = E1;
          E1 = D1;
          D1 = bit_rol(C1, 10);
          C1 = B1;
          B1 = T;
          T = safe_add(A2, rmd160_f(79 - j, B2, C2, D2));
          T = safe_add(T, x[i + rmd160_r2[j]]);
          T = safe_add(T, rmd160_K2(j));
          T = safe_add(bit_rol(T, rmd160_s2[j]), E2);
          A2 = E2;
          E2 = D2;
          D2 = bit_rol(C2, 10);
          C2 = B2;
          B2 = T;
        }

        T = safe_add(h1, safe_add(C1, D2));
        h1 = safe_add(h2, safe_add(D1, E2));
        h2 = safe_add(h3, safe_add(E1, A2));
        h3 = safe_add(h4, safe_add(A1, B2));
        h4 = safe_add(h0, safe_add(B1, C2));
        h0 = T;
      }
      return [h0, h1, h2, h3, h4];
    }

    // specific algorithm methods

    function rmd160_f(j, x, y, z) {
      return 0 <= j && j <= 15 ? x ^ y ^ z : 16 <= j && j <= 31 ? x & y | ~x & z : 32 <= j && j <= 47 ? (x | ~y) ^ z : 48 <= j && j <= 63 ? x & z | y & ~z : 64 <= j && j <= 79 ? x ^ (y | ~z) : 'rmd160_f: j out of range';
    }

    function rmd160_K1(j) {
      return 0 <= j && j <= 15 ? 0x00000000 : 16 <= j && j <= 31 ? 0x5a827999 : 32 <= j && j <= 47 ? 0x6ed9eba1 : 48 <= j && j <= 63 ? 0x8f1bbcdc : 64 <= j && j <= 79 ? 0xa953fd4e : 'rmd160_K1: j out of range';
    }

    function rmd160_K2(j) {
      return 0 <= j && j <= 15 ? 0x50a28be6 : 16 <= j && j <= 31 ? 0x5c4dd124 : 32 <= j && j <= 47 ? 0x6d703ef3 : 48 <= j && j <= 63 ? 0x7a6d76e9 : 64 <= j && j <= 79 ? 0x00000000 : 'rmd160_K2: j out of range';
    }
  }
};

module.exports = Hashes;

/***/ }),

/***/ "FdVw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GwN5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export API_URL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return API_AI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return API_SHARE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AND_DOWN_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return IOS_DOWN_URL; });
/* unused harmony export WX_SERVER */
/* unused harmony export WECHAT_APPID */
var API_URL = 'https://api.weixin.qq.com/sns/oauth2/access_token';

var API_AI = window.location.hostname == 'm.ytgrading.com' ? 'http://ai.ytgrading.com' : 'http://ft1ai.ytgrading.com';

var API_SHARE_URL = API_AI + '/wxtoken/getJsSignature';

var AND_DOWN_URL = 'http://app.so.com/detail/index?pname=com.collectiontoolapp.www&id=3960785';
var IOS_DOWN_URL = 'https://itunes.apple.com/cn/app/%E9%87%91%E7%8C%B4%E8%AF%86%E5%AE%9D/id1342117089?mt=8';

// 微信分享服务器
var WX_SERVER = 'https://wx.zhaoonline.com';
var WECHAT_APPID = window.location.hostname == 'h5.zhaoonline.com' ? 'wx57a1cb5eec49bd9f' : 'wxaa40fcdea349de54';

/***/ }),

/***/ "HjUU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("mUbh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_app__ = __webpack_require__("WSTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_stamps__ = __webpack_require__("q2+k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_login_getCode__ = __webpack_require__("vz0Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_login_login__ = __webpack_require__("tyhV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_login_getWxUser__ = __webpack_require__("gMbw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_login_checkIsBind__ = __webpack_require__("oH3k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_login_forgetCode__ = __webpack_require__("c2ef");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_login_resetPwd__ = __webpack_require__("cUe8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_login_bindUser__ = __webpack_require__("fkR9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_share_setShareInfo__ = __webpack_require__("BFDI");
// src/store/index.js














__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
  modules: {
    app: __WEBPACK_IMPORTED_MODULE_3__modules_app__["a" /* default */],
    album: __WEBPACK_IMPORTED_MODULE_4__modules_stamps__["a" /* default */],
    getMsgCode: __WEBPACK_IMPORTED_MODULE_5__modules_login_getCode__["a" /* default */],
    login: __WEBPACK_IMPORTED_MODULE_6__modules_login_login__["a" /* default */],
    getWxUser: __WEBPACK_IMPORTED_MODULE_7__modules_login_getWxUser__["a" /* default */],
    checkIsBind: __WEBPACK_IMPORTED_MODULE_8__modules_login_checkIsBind__["a" /* default */],
    forgetCode: __WEBPACK_IMPORTED_MODULE_9__modules_login_forgetCode__["a" /* default */],
    resetPwd: __WEBPACK_IMPORTED_MODULE_10__modules_login_resetPwd__["a" /* default */],
    bindUser: __WEBPACK_IMPORTED_MODULE_11__modules_login_bindUser__["a" /* default */],
    setShareInfo: __WEBPACK_IMPORTED_MODULE_12__modules_share_setShareInfo__["a" /* default */]
  }
}));

/***/ }),

/***/ "L/hj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Cookie; });
/* unused harmony export setWebViewJavascriptBridge */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Bridge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Authentication; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getPlatform; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getDevice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getQueryString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getUrlQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getViewData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_hashes__ = __webpack_require__("DNrh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_hashes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_js_hashes__);



/**
 * cookie操作
 */
var Cookie = {
    set: function set(name, value) {
        window.document.cookie = name + "=" + value;
    },
    get: function get(name) {
        var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
        return v ? v[2] : null;
    },
    delete: function _delete(name) {
        this.set(name, '', -1);
    }
};

var setWebViewJavascriptBridge = function setWebViewJavascriptBridge(cb) {
    function initWebViewJavascriptBridge() {
        if (window.WebViewJavascriptBridge && WebViewJavascriptBridge.init && !WebViewJavascriptBridge._messageHandler) {
            // console.log('init--1');
            WebViewJavascriptBridge.init(function (message, responseCallback) {
                // console.log('JS got a message', message);
                var data = {
                    'Javascript Responds': '测试中文!'
                };
                // console.log('JS responding with', data);
                responseCallback(data);
            });
        }
    }

    if (window.WebViewJavascriptBridge) {
        initWebViewJavascriptBridge();
        // console.log('initBefore--');
        return cb(window.WebViewJavascriptBridge);
    }
    document.addEventListener('WebViewJavascriptBridgeReady', function () {
        initWebViewJavascriptBridge();
        cb(WebViewJavascriptBridge);
        // console.log('initBefore--',WebViewJavascriptBridge);
    }, false);
    initWebViewJavascriptBridge();
    if (window.WVJBCallbacks) {
        return window.WVJBCallbacks.push(cb);
    }
    window.WVJBCallbacks = [cb];
    var WVJBIframe = document.createElement('iframe');
    WVJBIframe.style.display = 'none';
    WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__';
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(function () {
        document.documentElement.removeChild(WVJBIframe);
    }, 0);
};

var Bridge = function Bridge(web, native) {
    // console.log(window.navigator);
    if (window.navigator.userAgent && window.navigator.userAgent.indexOf('zhaoonline') > -1) {
        if (native && typeof native == 'function') {
            setWebViewJavascriptBridge(function (bridge) {
                // console.log('执行bridge',bridge);
                native(bridge);
            });
        }
    } else {
        if (web && typeof web == 'function') web();
    }
};

/**
 * 加密算法
 */
var Authentication = function Authentication(appId, key, deviceId, HttpMothod, HttpPath) {
    var SecretAccessKey = key;
    var SHA1 = new __WEBPACK_IMPORTED_MODULE_1__assets_js_hashes___default.a.SHA1(),
        stringToSign = HttpMothod.toUpperCase() + '\n\n' + HttpPath + '\n' + deviceId,
        signature = SHA1.b64_hmac(SecretAccessKey, stringToSign);
    return 'ZHAO ' + appId + ':' + signature;
};

/**
 * 获取app类型
 */
var getPlatform = function getPlatform() {
    var result = {
        TYPE: '',
        APP: ''
    };
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        result.TYPE = 'ios';
    } else if (/(Android)/i.test(navigator.userAgent)) {
        result.TYPE = 'android';
    } else {
        result.TYPE = 'pc';
    }
    if (window.navigator.userAgent.indexOf('zhaoonline') > -1) {
        result.APP = 'zhaoonline';
    } else if (window.navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1) {
        result.APP = 'weixin';
    } else if (window.navigator.userAgent.toLowerCase().indexOf('weibo') > -1) {
        result.APP = 'weibo';
    } else {
        result.APP = 'default';
    }
    return result;
};

/**
 * 获取设备
 */
var getDevice = function getDevice(needle) {
    // alert(navigator.userAgent);
    var find = function find(needle) {
        return navigator.userAgent.toLowerCase().indexOf(needle) !== -1;
    };
    var device = {
        ios: function ios() {
            return this.iphone() || this.ipod() || this.ipad();
        },
        iphone: function iphone() {
            return !this.windows() && find('iphone');
        },
        ipod: function ipod() {
            return find('ipod');
        },
        ipad: function ipad() {
            return find('ipad');
        },
        android: function android() {
            //设备
            return !this.windows() && find('android');
        },
        androidPhone: function androidPhone() {
            //android 手机
            return this.android() && find('mobile');
        },
        androidTablet: function androidTablet() {
            //android 平板
            return this.android() && !find('mobile');
        },
        blackberry: function blackberry() {
            //黑莓
            return find('blackberry') || find('bb10') || find('rim');
        },
        blackberryPhone: function blackberryPhone() {
            return this.blackberry() && !find('tablet');
        },
        blackberryTablet: function blackberryTablet() {
            return this.blackberry() && find('tablet');
        },
        windows: function windows() {
            return find('windows');
        },
        windowsPhone: function windowsPhone() {
            return this.windows() && find('phone');
        },
        windowsTablet: function windowsTablet() {
            return this.windows() && find('touch') && !this.windowsPhone();
        },
        fxos: function fxos() {
            //Firefox
            return (find('(mobile;') || find('(tablet;')) && find('; rv:');
        },
        fxosPhone: function fxosPhone() {
            return this.fxos() && find('mobile');
        },
        fxosTablet: function fxosTablet() {
            return this.fxos() && find('tablet');
        },
        meego: function meego() {
            //诺基亚
            return find('meego');
        },
        cordova: function cordova() {
            return window.cordova && location.protocol === 'file:';
        },
        nodeWebkit: function nodeWebkit() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(window.process) === 'object';
        },
        mobile: function mobile() {
            return this.androidPhone() || this.iphone() || this.ipod() || this.windowsPhone() || this.blackberryPhone() || this.fxosPhone() || this.meego();
        },
        tablet: function tablet() {
            return this.ipad() || this.androidTablet() || this.blackberryTablet() || this.windowsTablet() || this.fxosTablet();
        },
        desktop: function desktop() {
            return !this.tablet() && !this.mobile();
        }
    };
    return device[needle]();
};
/**
 * 获取url参数
 */
var getQueryString = function getQueryString(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);return null;
};
/**
 * 获取url参数
 */
var getUrlQuery = function getUrlQuery(name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
};
/**
 * 获取屏幕尺寸
 */
var getViewData = function getViewData() {
    return {
        width: document.documentElement.clientWidth,
        height: document.documentElement.clientHeight
    };
};

/***/ }),

/***/ "LwPG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/**
 * Created by wumian on 17/11/21.
 */


function num9(value) {
  if (value < 10) {
    return '0' + value;
  } else {
    return value;
  }
}
// 注册
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('num9', num9);

function timeDian(value) {
  if (value) {
    var newDate = new Date(value);
    var year = newDate.getFullYear();
    var month = newDate.getMonth() + 1;
    var day = newDate.getDate();
    return year + '.' + month + '.' + day;
  } else {
    return '';
  }
}
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('timeDian', timeDian);

function nullTo0(value) {
  if (value) {
    return value;
  } else {
    return 0;
  }
}
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('nullTo0', nullTo0);

function dateLineToCH(value) {
  if (value) {
    var str = value;
    str = str.replace('-', '年');
    str = str.replace('-', '月');
    str = str + '日';
    return str;
  }
}
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('dateLineToCH', dateLineToCH);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xzd6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bd138f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("4VHz");
function injectStyle (ssrContext) {
  __webpack_require__("fKiY")
  __webpack_require__("FdVw")
  __webpack_require__("QNav")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7bd138f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bd138f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__("8+8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_js_adaptation__ = __webpack_require__("mY2S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_js_adaptation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_js_adaptation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_js_prototype__ = __webpack_require__("qerm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_iconfont_iconfont_css__ = __webpack_require__("/Eu8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_iconfont_iconfont_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_iconfont_iconfont_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_iconfont_iconfont_css__ = __webpack_require__("muQq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_iconfont_iconfont_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_iconfont_iconfont_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex_router_sync__ = __webpack_require__("9JMe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_fastclick__ = __webpack_require__("v5o6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_fastclick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_fastclick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_js_filter__ = __webpack_require__("LwPG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_js_directive__ = __webpack_require__("blYJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_components_loading_loading__ = __webpack_require__("DF5F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils__ = __webpack_require__("L/hj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_utils__ = __webpack_require__("oAV5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__config_const__ = __webpack_require__("GwN5");

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);


















/*
测试：http://ft1m.ytgrading.com
预发：http://prem.ytgrading.com
正式：http://m.ytgrading.com
*/

var debug = "production" != 'production';

if (debug) {
  var baseURL = __WEBPACK_IMPORTED_MODULE_19__config_const__["b" /* API_AI */] + '/';
} else {
  var baseURL = __WEBPACK_IMPORTED_MODULE_19__config_const__["b" /* API_AI */] + '/';
}

var instance = __WEBPACK_IMPORTED_MODULE_15_axios___default.a.create({
  baseURL: baseURL
});

// 添加请求拦截器
instance.interceptors.request.use(function (config) {
  var appId = __WEBPACK_IMPORTED_MODULE_17__utils__["c" /* Cookie */].get('appId') || 'fKhnk3UwbjhLP5NuFNQm5W';
  var appKey = __WEBPACK_IMPORTED_MODULE_17__utils__["c" /* Cookie */].get('appKey') || '9dbe75e0-d10a-55a5-b232-ecd60a9f60be';
  var deviceId = __WEBPACK_IMPORTED_MODULE_17__utils__["c" /* Cookie */].get('deviceId') || 'a7db4c9407af622a';
  var authorization = Object(__WEBPACK_IMPORTED_MODULE_17__utils__["a" /* Authentication */])(appId, appKey, deviceId, config.method, '/' + config.url);
  config.headers['X-Zhao-AppId'] = appId;
  config.headers['X-Zhao-DeviceId'] = deviceId;
  config.headers['X-Zhao-UserId'] = __WEBPACK_IMPORTED_MODULE_17__utils__["c" /* Cookie */].get('userId') || '';
  config.headers['X-Zhao-OSInfo'] = '{"os":"h5"}';
  config.headers['Authorization'] = authorization;
  return config;
}, function (err) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
});

// 添加响应拦截器
instance.interceptors.response.use(function (response) {

  // 对响应数据做点什么
  return response.data;
}, function (error) {
  //Toast.open('请求异常');
  // 对响应错误做点什么
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$ajax = instance;

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false; //Vue.config   虽然没有高亮,但是有值

Object(__WEBPACK_IMPORTED_MODULE_11_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */]);

if ('addEventListener' in document) {
  document.addEventListener('DOMContentLoaded', function () {
    __WEBPACK_IMPORTED_MODULE_12_fastclick___default.a.attach(document.body);
  }, false);
}

function init() {
  __webpack_require__("Yn/y");
  __webpack_require__("tok3");
}

Object(__WEBPACK_IMPORTED_MODULE_18__utils_utils__["b" /* domOnLoad */])(init);

__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].beforeEach(function (to, from, next) {

  next();
});

__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].afterEach(function (to, from) {
  document.title = to.meta.title || to.params.title || to.query.title;
});

new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ "QNav":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SZ1B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TVno":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WSTi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__("L/hj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_mutation_types__ = __webpack_require__("iMSY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_plugins_toast_index_js__ = __webpack_require__("3BeM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_plugins_loading_index_js__ = __webpack_require__("Y+qm");


var _mutations;







__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vux_src_plugins_toast_index_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vux_src_plugins_loading_index_js__["a" /* default */]);

window.toast = null;
window.loading = null;
var clientInfo = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["h" /* getViewData */])();

var state = {
  clientInfo: clientInfo
};

var getters = {
  getterClientInfo: function getterClientInfo(state) {
    return state.clientInfo;
  }
};

var actions = {
  showToast: function showToast(_ref, options) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__config_mutation_types__["m" /* APP_FAILURE */], options);
  },
  showLoading: function showLoading(_ref2, options) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__config_mutation_types__["p" /* APP_LOADING */], options);
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__config_mutation_types__["p" /* APP_LOADING */], function (state, data) {
  if (window.loading || !data) {
    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].$vux.loading.hide();
  }
  if (!data) {
    window.loading = __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].$vux.toast.show({
      'show': data && data.show ? data.show : true,
      'text': data && data.text ? data.text : '加载中 ...',
      'position': data && data.postion ? data.positon : 'middle'
    });
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__config_mutation_types__["m" /* APP_FAILURE */], function (state, data) {
  if (window.toast) {
    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].$vux.toast.hide();
  }
  window.toast = __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].$vux.toast.show({
    'time': data && data.time ? data.time : 2500,
    'type': data && data.type ? data.type : 'text',
    'width': data && data.width ? data.width : '7.6em',
    'is-show-mask': data && data.isShowMask ? data.isShowMask : true,
    'show': data && data.show ? data.show : true,
    'text': data && data.text ? data.text : '消息',
    'position': data && data.postion ? data.positon : 'middle'
  });
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "XJvr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-loading_toast vux-loading"},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast",style:({ position: _vm.position })},[_c('i',{staticClass:"weui-loading weui-icon_toast"}),_vm._v(" "),_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.text || '加载中')),_vm._t("default")],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrong__ = __webpack_require__("fCtu");




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '*',
    name: 'Wrong',
    component: __WEBPACK_IMPORTED_MODULE_2__components_wrong__["a" /* default */]
  }, {
    path: '/',
    name: 'Index',
    meta: {
      title: '首页'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("L8Y5")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/login/index',
    name: 'loginIndex',
    meta: {
      title: '登录'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(18).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("q8bm")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/login/login',
    name: 'Login',
    meta: {
      title: '登录'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("6Qob")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/login/bindLogin',
    name: 'BindLogin',
    meta: {
      title: '绑定'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("TmTh")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/login/resetPwd',
    name: 'ResetPwd',
    meta: {
      title: '重置密码'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("GUkr")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/login/userXieyi',
    name: 'UserXieyi',
    meta: {
      title: '用户协议'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("wuGm")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/rankingList/rankingList',
    name: 'rankingList',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("3Uv/")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '排行',
      keepAlive: false,
      auth: false
    }
  }, {
    path: '/rankExplain/rankExplain',
    name: 'rankExplain',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ROu0")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '等级说明',
      keepAlive: true,
      auth: false
    }
  }, {
    path: '/showImage/showImage',
    name: 'showImage',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("mxyJ")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '晒图详情',
      keepAlive: true,
      auth: false
    }
  }, {
    path: '/stamp/stamp',
    name: 'stamp',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("IENg")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '邮册单票详情',
      keepAlive: false,
      auth: false
    }
  }, {
    path: '/stamps/stamps',
    name: 'stamps',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("VOQs")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '邮册',
      keepAlive: false,
      auth: false
    }
  }, {
    path: '/stampAlbum/stampAlbum',
    name: 'stampAlbum',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("zM6x")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '邮集单票详情',
      keepAlive: true,
      auth: false
    }
  }, {
    path: '/shareDetail/shareDetail',
    name: 'shareDetail',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("OYAp")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '详情',
      keepAlive: true,
      auth: false
    }
  }, {
    path: '/aboutWe/aboutWe',
    name: 'aboutWe',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(17).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("YPjI")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '关于我们',
      keepAlive: true,
      auth: false
    }
  }, {
    path: '/scratchCard/index',
    name: 'ScratchCardIndex',
    meta: {
      title: '抽奖'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(16).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("jinD")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/stamps/read',
    name: 'stampsRead',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("xqrB")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '邮册翻阅',
      keepAlive: false,
      auth: false
    }
  }, {
    path: '/stamps/list',
    name: 'stampsList',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("YmKJ")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '邮册列表',
      keepAlive: false,
      auth: false
    }
  }, {
    path: '/stamps/stampsNewHot',
    name: 'stampsNewHot',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("/WkM")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '邮册',
      keepAlive: false,
      auth: false
    }
  }, {
    path: '/stamps/stampDetail',
    name: 'stampDetail',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("8SdQ")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '',
      keepAlive: false,
      auth: false
    }
  }]
}));

/***/ }),

/***/ "Yn/y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator__ = __webpack_require__("Zzip");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol__ = __webpack_require__("5QVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol__);





var _typeof = "function" == typeof __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol___default.a && "symbol" == __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator___default.a) ? function (t) {
  return typeof t === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(t);
} : function (t) {
  return t && "function" == typeof __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol___default.a && t.constructor === __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol___default.a && t !== __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol___default.a.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(t);
};!function (t) {
  var s = { setting: { time: 2500, info: "", type: "text", ico: "", position: "center", class: "" }, settingResult: {}, open: function open(t) {
      if (this.settingResult = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.setting)), "object" == (void 0 === t ? "undefined" : _typeof(t))) for (var s in t) {
        this.settingResult[s] = t[s];
      } else this.settingResult.info = "string" == typeof t ? t : "使用方式不正确";if (!this.settingResult.ico) switch (this.settingResult.type) {case "fail":
          this.settingResult.ico = "icon-cuowuguanbiquxiao-yuankuang";break;case "success":
          this.settingResult.ico = "icon-success";default:
          this.settingResult.ico = "";}if (!this.settingResult.info) switch (this.settingResult.type) {case "fail":
          this.settingResult.info = "失败";break;case "success":
          this.settingResult.info = "成功";default:
          this.settingResult.info = "";}this.toast ? this.toast.style.display = "block" : (this.toast = document.createElement("div"), this.toast.className = "w-toasting w-" + this.settingResult.type + " " + this.settingResult.class, this.toast.innerHTML = '\n<div class="w-toast w-' + this.settingResult.position + '">\n            <div class="w-ico">\n                <i class="iconfont ' + this.settingResult.ico + '"></i>\n            </div>\n            <div class="w-ico_info">\n               ' + this.settingResult.info + "\n            </div>\n            </div>\n\n      ", document.body.appendChild(this.toast));var i = this;setTimeout(function () {
        i.close();
      }, this.settingResult.time);
    }, close: function close() {
      this == t ? this.Toast.toast && (this.Toast.toast.style.display = "none") : this.toast.style.display = "none";
    } };"object" === (void 0 === t ? "undefined" : _typeof(t)) && "object" === _typeof(t.document) && (t.Toast = s);
}(window);

/***/ }),

/***/ "Z5JB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});

/***/ }),

/***/ "blYJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/**
 * Created by wumian on 17/11/21.
 */


// 注册一个全局自定义指令 `v-focus`
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('focus', {
  inserted: function inserted(el) {
    el.focus();
  },
  update: function update(el) {
    el.focus();
  }
});

/***/ }),

/***/ "c2ef":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_mutation_types__ = __webpack_require__("iMSY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_const__ = __webpack_require__("GwN5");



var _mutations;

// src/store/modules/account.js



__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);





var state = {
    apiInfo: ''
};

var getters = {
    getForgetCode: function getForgetCode(state) {
        return state.apiInfo;
    }
};

var actions = {
    getForgetCode: function getForgetCode(_ref, options) {
        var commit = _ref.commit;

        var uri = __WEBPACK_IMPORTED_MODULE_5__config_const__["b" /* API_AI */] + "/h5/auth/sendForgetPwdCaptcha/" + options.data.mobile;
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.get(uri).then(function (res, err) {
                resolve(res.data);
            }, function (res) {
                reject(res.data);
            });
        }).then(function (res) {
            commit(__WEBPACK_IMPORTED_MODULE_4__config_mutation_types__["d" /* API_FORGETCODE_INFO */], res);
        }, function (err) {
            commit(__WEBPACK_IMPORTED_MODULE_4__config_mutation_types__["n" /* APP_FORGETCODE_FAILURE */], err + '获取信息失败');
        });
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__config_mutation_types__["d" /* API_FORGETCODE_INFO */], function (state, data) {
    state.apiInfo = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__config_mutation_types__["n" /* APP_FORGETCODE_FAILURE */], function (state, data) {
    state.apiInfo = data;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ "cUe8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_mutation_types__ = __webpack_require__("iMSY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_const__ = __webpack_require__("GwN5");



var _mutations;

// src/store/modules/account.js



__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);





var state = {
    apiInfo: ''
};

var getters = {
    resetPwd: function resetPwd(state) {
        return state.apiInfo;
    }
};

var actions = {
    resetPwd: function resetPwd(_ref, options) {
        var commit = _ref.commit;

        var uri = __WEBPACK_IMPORTED_MODULE_5__config_const__["b" /* API_AI */] + "/h5/auth/modifyLoginPasswordByPhoneCode";
        if (options.data.from && options.data.redirect) {
            uri += '?from=' + options.data.from + '&redirect=' + options.data.redirect;
        }
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post(uri, {
                mobile: options.data.mobile,
                validationCode: options.data.validationCode,
                newPassword: options.data.newPassword
            }).then(function (res, err) {
                resolve(res.data);
            }, function (res) {
                reject(res.data);
            });
        }).then(function (res) {
            commit(__WEBPACK_IMPORTED_MODULE_4__config_mutation_types__["j" /* API_RESETPWD_INFO */], res);
        }, function (err) {
            commit(__WEBPACK_IMPORTED_MODULE_4__config_mutation_types__["t" /* APP_RESETPWD_FAILURE */], err + '获取信息失败');
        });
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__config_mutation_types__["j" /* API_RESETPWD_INFO */], function (state, data) {
    state.apiInfo = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__config_mutation_types__["t" /* APP_RESETPWD_FAILURE */], function (state, data) {
    state.apiInfo = data;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ "fCtu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_wrong_vue__ = __webpack_require__("B9BE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02aa07bf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_wrong_vue__ = __webpack_require__("6NR2");
function injectStyle (ssrContext) {
  __webpack_require__("HjUU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_wrong_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02aa07bf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_wrong_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fKiY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fkR9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_mutation_types__ = __webpack_require__("iMSY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_const__ = __webpack_require__("GwN5");



var _mutations;

// src/store/modules/account.js



__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);





var state = {
    apiInfo: ''
};

var getters = {
    getBind: function getBind(state) {
        return state.apiInfo;
    }
};

var actions = {
    getBind: function getBind(_ref, options) {
        var commit = _ref.commit;

        var uri = __WEBPACK_IMPORTED_MODULE_5__config_const__["b" /* API_AI */] + "/h5/auth/thirdPartyBindingAndLogin";
        if (options.data.from && options.data.redirect) {
            uri += '?from=' + options.data.from + '&redirect=' + options.data.redirect;
        }
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post(uri, {
                mobilePhone: options.data.mobilePhone,
                validationCode: options.data.validationCode,
                channelId: options.data.channelId,
                openId: options.data.openId,
                unionId: options.data.unionId,
                nickname: options.data.nickname,
                headImgUrl: options.data.headImgUrl
            }).then(function (res, err) {
                resolve(res.data);
            }, function (res) {
                reject(res.data);
            });
        }).then(function (res) {
            commit(__WEBPACK_IMPORTED_MODULE_4__config_mutation_types__["c" /* API_BIND_INFO */], res);
        }, function (err) {
            commit(__WEBPACK_IMPORTED_MODULE_4__config_mutation_types__["l" /* APP_BIND_FAILURE */], err + '获取信息失败');
        });
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__config_mutation_types__["c" /* API_BIND_INFO */], function (state, data) {
    state.apiInfo = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__config_mutation_types__["l" /* APP_BIND_FAILURE */], function (state, data) {
    state.apiInfo = data;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ "gMbw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_mutation_types__ = __webpack_require__("iMSY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_const__ = __webpack_require__("GwN5");



var _mutations;

// src/store/modules/account.js



__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);





var state = {
    apiInfo: ''
};

var getters = {
    getUserInfo: function getUserInfo(state) {
        return state.apiInfo;
    }
};

var actions = {
    getUserInfo: function getUserInfo(_ref, options) {
        var commit = _ref.commit;

        var uri = __WEBPACK_IMPORTED_MODULE_5__config_const__["b" /* API_AI */] + "/h5/auth/getAccessToken/" + options.data.id;
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post(uri, {
                client_id: options.data.key,
                client_secret: options.data.secret,
                grant_type: 'authorization_code',
                redirect_uri: location.href,
                code: options.data.code
            }).then(function (res, err) {
                resolve(res.data);
            }, function (res) {
                reject(res.data);
            });
        }).then(function (res) {
            commit(__WEBPACK_IMPORTED_MODULE_4__config_mutation_types__["k" /* API_USER_INFO */], res);
        }, function (err) {
            commit(__WEBPACK_IMPORTED_MODULE_4__config_mutation_types__["u" /* APP_USER_FAILURE */], err + '获取信息失败');
        });
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__config_mutation_types__["k" /* API_USER_INFO */], function (state, data) {
    state.apiInfo = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__config_mutation_types__["u" /* APP_USER_FAILURE */], function (state, data) {
    state.apiInfo = data;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ "iMSY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return API_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return APP_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return APP_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return API_USER_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return APP_USER_FAILURE; });
/* unused harmony export API_OPENID_INFO */
/* unused harmony export APP_OPENID_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return API_ISBIND_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return APP_ISBIND_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return API_MSGCODE_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return APP_MSGCODE_FAILURE; });
/* unused harmony export API_REGISTER_INFO */
/* unused harmony export APP_REGISTER_FAILURE */
/* unused harmony export API_SUBMIT_INFO */
/* unused harmony export APP_SUBMIT_FAILURE */
/* unused harmony export API_GETRP_INFO */
/* unused harmony export APP_GETRP_FAILURE */
/* unused harmony export API_TIME_INFO */
/* unused harmony export APP_TIME_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return API_BIND_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return APP_BIND_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return API_LOGIN_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return APP_LOGIN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return API_MOBILE_LOGIN_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return APP_MOBILE_LOGIN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return API_FORGETCODE_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return APP_FORGETCODE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return API_RESETPWD_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return APP_RESETPWD_FAILURE; });
/* unused harmony export APP_WX_SHARE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALBUM_PAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ALBUM_SERIES; });

var API_INFO = 'API_INFO';
var APP_LOADING = 'APP_LOADING';
var APP_FAILURE = 'APP_FAILURE';
var API_USER_INFO = 'API_USER_INFO';
var APP_USER_FAILURE = 'APP_USER_FAILURE';
var API_OPENID_INFO = 'API_OPENID_INFO';
var APP_OPENID_FAILURE = 'APP_OPENID_FAILURE';
var API_ISBIND_INFO = 'API_ISBIND_INFO';
var APP_ISBIND_FAILURE = 'APP_ISBIND_FAILURE';
var API_MSGCODE_INFO = 'API_MSGCODE_INFO';
var APP_MSGCODE_FAILURE = 'APP_MSGCODE_FAILURE';
var API_REGISTER_INFO = 'API_REGISTER_INFO';
var APP_REGISTER_FAILURE = 'APP_REGISTER_FAILURE';
var API_SUBMIT_INFO = 'API_SUBMIT_INFO';
var APP_SUBMIT_FAILURE = 'APP_SUBMIT_FAILURE';
var API_GETRP_INFO = 'API_SUBMIT_INFO';
var APP_GETRP_FAILURE = 'APP_SUBMIT_FAILURE';
var API_TIME_INFO = 'API_TIME_INFO';
var APP_TIME_FAILURE = 'APP_TIME_FAILURE';
var API_BIND_INFO = 'API_BIND_INFO';
var APP_BIND_FAILURE = 'APP_BIND_FAILURE';
var API_LOGIN_INFO = 'API_LOGIN_INFO';
var APP_LOGIN_FAILURE = 'APP_LOGIN_FAILURE';
var API_MOBILE_LOGIN_INFO = 'API_MOBILE_LOGIN_INFO';
var APP_MOBILE_LOGIN_FAILURE = 'APP_MOBILE_LOGIN_FAILURE';
var API_FORGETCODE_INFO = 'API_FORGETCODE_INFO';
var APP_FORGETCODE_FAILURE = 'APP_FORGETCODE_FAILURE';
var API_RESETPWD_INFO = 'API_RESETPWD_INFO';
var APP_RESETPWD_FAILURE = 'APP_RESETPWD_FAILURE';
var APP_WX_SHARE = 'APP_WX_SHARE';

// album
var ALBUM_PAGES = 'ALBUM_PAGES';
var ALBUM_SERIES = 'ALBUM_SERIES';

/***/ }),

/***/ "mUbh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerBridgeTokenInfo", function() { return registerBridgeTokenInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__("8+8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_const__ = __webpack_require__("GwN5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__("L/hj");
// src/store/actions.js






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);

// HTTP相关
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.options.crossOrigin = true;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.options.credentials = true;

/**
 * 请求处理
 */
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.interceptors.push(function (request, next) {
    // 这里对请求体进行处理
    Object(__WEBPACK_IMPORTED_MODULE_4__utils__["b" /* Bridge */])(function () {
        var appId = 'fKhnk3UwbjhLP5NuFNQm5W';
        var appKey = '9dbe75e0-d10a-55a5-b232-ecd60a9f60be';
        var deviceId = 'FBED7066-9101-40CE-8C4E-EAA22C887346';
        request.headers = request.headers || {};
        request.headers.set('Content-Type', 'application/json');
        request.headers.set('X-Zhao-AppId', appId);
        request.headers.set('X-Zhao-DeviceId', deviceId);
        request.headers.set('X-Zhao-OSInfo', '{"os":"h5"}');
        request.headers.set('Authorization', Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* Authentication */])(appId, appKey, deviceId, request.method, request.url.replace(__WEBPACK_IMPORTED_MODULE_3__config_const__["b" /* API_AI */], '').split('?')[0]));

        next(function (response) {
            return response;
        });
    }, function (bridge) {
        bridge.callHandler('getDeviceInfo', {}, function (response) {
            if (Object(__WEBPACK_IMPORTED_MODULE_4__utils__["d" /* getDevice */])('android')) {
                response = JSON.parse(response);
            } else {
                response = response;
            }
            request.headers = request.headers || {};
            request.headers.set('Content-Type', 'application/json');
            request.headers.set('X-Zhao-AppId', response.appId);
            request.headers.set('X-Zhao-DeviceId', response.deviceId);
            request.headers.set('X-Zhao-OSInfo', response.OSInfo);
            request.headers.set('Authorization', Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* Authentication */])(response.appId, response.appKey, response.deviceId, request.method, request.url.replace(__WEBPACK_IMPORTED_MODULE_3__config_const__["b" /* API_AI */], '').split('?')[0]));
            next(function (response) {
                if (response.status !== 200) {} else {
                    response.data = response.json();
                    if (response.url.indexOf('/wxtoken/getJsSignature') == -1 && response.data.status && response.data.status != 'SUCCESS') {}
                }
            });
        });
    });
});

/*
* 注册一个获取用户基本加密信息
* */
var registerBridgeTokenInfo = function registerBridgeTokenInfo(_ref) {
    var commit = _ref.commit;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    Object(__WEBPACK_IMPORTED_MODULE_4__utils__["b" /* Bridge */])(function () {
        if (options.successWeb) options.successWeb();
    }, function (bridge) {
        bridge.registerHandler('tokenInfo', function (response) {
            if (typeof response == 'string') {
                var data = JSON.parse(response);
            } else {
                var data = response;
            }
            if (data) {
                __WEBPACK_IMPORTED_MODULE_4__utils__["c" /* Cookie */].set('appId', data.appId);
                __WEBPACK_IMPORTED_MODULE_4__utils__["c" /* Cookie */].set('appKey', data.appKey);
                __WEBPACK_IMPORTED_MODULE_4__utils__["c" /* Cookie */].set('userId', data.userId);
                __WEBPACK_IMPORTED_MODULE_4__utils__["c" /* Cookie */].set('deviceId', data.deviceId);
            }
            if (options.successNative) options.successNative(data);
        });
    });
};

/***/ }),

/***/ "mY2S":
/***/ (function(module, exports) {


(function (doc, win) {
  var docEl = doc.documentElement,
      resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
      recalc = function recalc() {
    docEl.setAttribute('data-dpr', win.devicePixelRatio);
    var clientWidth = docEl.clientWidth;
    clientWidth = clientWidth > 540 ? 540 : clientWidth;
    docEl.style.width = clientWidth + "px";
    docEl.style.height = docEl.clientHeight + "px";
    if (!clientWidth) return;
    docEl.style.fontSize = clientWidth / 10 + 'px';
  };

  if (!doc.addEventListener) return;
  win.addEventListener(resizeEvt, recalc, false);
  doc.addEventListener('DOMContentLoaded', recalc, false);
})(document, window);

/***/ }),

/***/ "muQq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nQpb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_safari_fix__ = __webpack_require__("xNvf");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'toast',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_safari_fix__["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});

/***/ }),

/***/ "oAV5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export reSetCookier */
/* harmony export (immutable) */ __webpack_exports__["d"] = scrollBottom;
/* unused harmony export IsPC */
/* harmony export (immutable) */ __webpack_exports__["c"] = getUrlParams;
/* unused harmony export cutString */
/* harmony export (immutable) */ __webpack_exports__["b"] = domOnLoad;
/* unused harmony export winOnLoad */
/* unused harmony export type */
/* harmony export (immutable) */ __webpack_exports__["a"] = changeNull;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__("L/hj");
/**
 * Created by wumian on 17/12/19.
 */


var reSetCookier = function reSetCookier(obj) {
  for (var key in obj) {
    __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* Cookie */].set(key, obj[key]);
  }
};

function scrollBottom(el) {
  var offsetHeight = el.offsetHeight,
      scrollTop = el.scrollTop,
      scrollHeight = el.scrollHeight;

  if (offsetHeight + scrollTop + 5 >= scrollHeight && scrollTop != 0) {

    return true;
  }
}

function IsPC() {
  var userAgentInfo = navigator.userAgent;
  var Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}

function getUrlParams(name) {
  var reg = new RegExp("(^|&|\\?)" + name + "=([^&]*)(&|$)");
  var r = window.location.href.match(reg);
  if (r != null) return r[2];return null;
}

function cutString(string, name) {
  var str = string;
  var index = str.indexOf(name);
  var result = str.substring(index + name.length);
  return result;
}

function domOnLoad(init) {
  // 如果支持 W3C DOM2, 则使用 W3C 方法
  if (document.addEventListener) {
    document.addEventListener("DOMContentLoaded", init, false);

    // 如果是 IE 浏览器
  } else if (/MSIE/i.test(navigator.userAgent)) {
    // 创建一个 script 标签, 该标签有 defer 属性, 当 document 加载完毕时才会被载入
    document.write('<script id="__ie_onload" defer src="javascript:void(0)"></script>');
    var script = document.getElementById("__ie_onload");
    // 如果文档确实装载完毕, 调用初始化方法
    script.onreadystatechange = function () {
      if (this.readyState == 'complete') {
        init();
      }
    };

    // 如果是 Safari 浏览器
  } else if (/WebKit/i.test(navigator.userAgent)) {
    // 创建定时器, 每 0.01 秒检验一次, 如果文档装载完毕则调用初始化方法
    var _timer = setInterval(function () {
      if (/loaded|complete/.test(document.readyState)) {
        clearInterval(_timer);
        init();
      }
    }, 10);

    // 如果以上皆不是, 使用最坏的方法 (本例中, Opera 7 将会跑到这里来)
  } else {
    window.onload = function (e) {
      init();
    };
  }
}

function winOnLoad(init) {
  function downloadJSAtOnload() {
    init();
  }
  if (window.addEventListener) {
    window.addEventListener("load", downloadJSAtOnload, false);
  } else if (window.attachEvent) {
    window.attachEvent("onload", downloadJSAtOnload);
  } else {
    window.onload = downloadJSAtOnload;
  }
}

function type(obj) {
  var result = {}.toString.call(obj).split(' ')[1];
  return result.substr(0, result.length - 1).toLowerCase();
}

function changeNull(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (obj[key] == 'null' || type(obj[key]) == 'null') {
        obj[key] = '';
      } else {
        if (type(obj[key]) == 'object') {
          changeNull(obj[key]);
        }
      }
    }
  }
}

/***/ }),

/***/ "oH3k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_mutation_types__ = __webpack_require__("iMSY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_const__ = __webpack_require__("GwN5");



var _mutations;

// src/store/modules/account.js



__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);





var state = {
    apiInfo: ''
};

var getters = {
    getIsBind: function getIsBind(state) {
        return state.apiInfo;
    }
};

var actions = {
    getIsBind: function getIsBind(_ref, options) {
        var commit = _ref.commit;

        var uri = __WEBPACK_IMPORTED_MODULE_5__config_const__["b" /* API_AI */] + "/h5/auth/checkThirdPartyUser/" + options.data.methodid + "/" + options.data.openid + "/" + options.data.unionid;
        if (options.data.from && options.data.redirect) {
            uri += '?from=' + options.data.from + '&redirect=' + options.data.redirect;
        }
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.get(uri).then(function (res, err) {
                resolve(res.data);
            }, function (res) {
                reject(res.data);
            });
        }).then(function (res) {
            commit(__WEBPACK_IMPORTED_MODULE_4__config_mutation_types__["f" /* API_ISBIND_INFO */], res);
        }, function (err) {
            commit(__WEBPACK_IMPORTED_MODULE_4__config_mutation_types__["o" /* APP_ISBIND_FAILURE */], err + '获取信息失败');
        });
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__config_mutation_types__["f" /* API_ISBIND_INFO */], function (state, data) {
    state.apiInfo = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__config_mutation_types__["o" /* APP_ISBIND_FAILURE */], function (state, data) {
    state.apiInfo = data;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ "q2+k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__("L/hj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_stamps__ = __webpack_require__("tHJd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_mutation_types__ = __webpack_require__("iMSY");


var _mutations;

// src/store/modules/app.js




var state = {
  myPages: '',
  albumSeries: []
};

var getters = {
  getterMyPages: function getterMyPages(state) {
    return state.myPages;
  },
  getterAlbumSeries: function getterAlbumSeries(state) {
    return state.albumSeries;
  }
};

var actions = {
  getMyPages: function getMyPages(_ref, options) {
    var commit = _ref.commit;

    if (!window.navigator.onLine) {
      alt('似乎已断开与互联网的链接');
    } else {
      return Object(__WEBPACK_IMPORTED_MODULE_2__api_stamps__["c" /* apiMyPages */])(options.data ? options.data : {}).then(function (res) {
        if (res.data.resultCode == 0) {
          commit(__WEBPACK_IMPORTED_MODULE_3__config_mutation_types__["a" /* ALBUM_PAGES */], res.data.data);
          if (res.data.data.list.length > 0) {
            if (options.success) options.success();
          } else {
            commit(__WEBPACK_IMPORTED_MODULE_3__config_mutation_types__["m" /* APP_FAILURE */], {
              type: 'text',
              text: '没有相册'
            });
          }
        } else {
          commit(__WEBPACK_IMPORTED_MODULE_3__config_mutation_types__["m" /* APP_FAILURE */], {
            type: 'text',
            text: res.data.resultMsg
          });
        }
      }).catch(function (err) {
        commit(__WEBPACK_IMPORTED_MODULE_3__config_mutation_types__["m" /* APP_FAILURE */], {
          text: err.data.resultMsg
        });
      });
    }
  },
  getAlbumSeries: function getAlbumSeries(_ref2) {
    var commit = _ref2.commit;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!window.navigator.onLine) {
      alt('似乎已断开与互联网的链接');
    } else {
      return Object(__WEBPACK_IMPORTED_MODULE_2__api_stamps__["a" /* apiAlbumSeries */])(options.data).then(function (res) {
        if (res.status == 200 && res.data && res.data.resultCode == 0) {
          commit(__WEBPACK_IMPORTED_MODULE_3__config_mutation_types__["b" /* ALBUM_SERIES */], res.data.data);
          options.success();
        } else {
          commit(__WEBPACK_IMPORTED_MODULE_3__config_mutation_types__["m" /* APP_FAILURE */], {
            type: 'text',
            text: res.data.resultMsg
          });
        }
      }).catch(function (err) {
        commit(__WEBPACK_IMPORTED_MODULE_3__config_mutation_types__["m" /* APP_FAILURE */], {
          text: '获取邮册失败'
        });
      });
    }
  },
  getImgNewHot: function getImgNewHot(_ref3) {
    var commit = _ref3.commit;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!window.navigator.onLine) {
      alt('似乎已断开与互联网的链接');
    } else {
      return Object(__WEBPACK_IMPORTED_MODULE_2__api_stamps__["b" /* apiImgNewHot */])(options.data).then(function (res) {
        if (res.status == 200 && res.data && res.data.resultCode == 0) {
          options.success(res.data.data);
        } else {
          commit(__WEBPACK_IMPORTED_MODULE_3__config_mutation_types__["m" /* APP_FAILURE */], {
            type: 'text',
            text: res.data.resultMsg
          });
        }
      }).catch(function (error) {
        commit(__WEBPACK_IMPORTED_MODULE_3__config_mutation_types__["m" /* APP_FAILURE */], {
          text: error.data.resultMsg
        });
      });
    }
  },
  thumbUpRequest: function thumbUpRequest(_ref4) {
    var commit = _ref4.commit;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!window.navigator.onLine) {
      alt('似乎已断开与互联网的链接');
    } else {
      return Object(__WEBPACK_IMPORTED_MODULE_2__api_stamps__["e" /* apiThumbUp */])(options.data).then(function (res) {
        if (res.status == 200 && res.data && res.data.resultCode == 0) {
          if (options.success) {
            options.success(res.data.data);
          }

          var msg = '';
          if (res.data.data.status == 'VALID') {
            msg = '点赞成功';
          }

          if (res.data.data.status == 'INVALID') {
            msg = '取消点赞成功';
          }

          commit(__WEBPACK_IMPORTED_MODULE_3__config_mutation_types__["m" /* APP_FAILURE */], {
            type: 'text',
            time: 1000,
            text: msg
          });
        } else {
          commit(__WEBPACK_IMPORTED_MODULE_3__config_mutation_types__["m" /* APP_FAILURE */], {
            type: 'text',
            text: res.data.resultMsg
          });
        }
      }).catch(function (error) {
        console.log(error);
        commit(__WEBPACK_IMPORTED_MODULE_3__config_mutation_types__["m" /* APP_FAILURE */], {
          type: 'text',
          text: error.data.resultMsg
        });
      });
    }
  },
  getStampsDetail: function getStampsDetail(_ref5) {
    var commit = _ref5.commit;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!window.navigator.onLine) {
      alt('似乎已断开与互联网的链接');
    } else {
      return Object(__WEBPACK_IMPORTED_MODULE_2__api_stamps__["d" /* apiStampsDetail */])(options.data).then(function (res) {
        if (res.status == 200 && res.data && res.data.resultCode == 0) {
          options.success(res.data);
        } else {
          commit(__WEBPACK_IMPORTED_MODULE_3__config_mutation_types__["m" /* APP_FAILURE */], {
            type: 'text',
            text: res.data.resultMsg
          });
        }
      }).catch(function (error) {
        commit(__WEBPACK_IMPORTED_MODULE_3__config_mutation_types__["m" /* APP_FAILURE */], {
          text: error.data.resultMsg
        });
      });
    }
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__config_mutation_types__["a" /* ALBUM_PAGES */], function (state, data) {
  state.myPages = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__config_mutation_types__["b" /* ALBUM_SERIES */], function (state, data) {
  state.albumSeries = data;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "qerm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);


/**
 * Created by wumian on 17/11/23.
 */

//数组中的  json去重  在排序  默认删除前者  从小到大排序  不会改变原数组
Array.prototype.jsonRepeatSort = function (key) {
  var typeSort = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'small';
  var typeRepeat = arguments[2];

  var that = this;
  var result = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(that);
  var arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(result);

  for (var j = 0; j < arr.length; j++) {
    if (j < arr.length) {
      var one = arr[j][key];
      for (var i = j + 1; i < arr.length; i++) {
        if (one == arr[i][key]) {
          if (typeRepeat == 'next') {
            arr.splice(i, 1); //删除的是后者   直接改变原数组
            i--;
          } else {
            arr.splice(j, 1); //删除的是前者, 默认删除前者
            j--;
            break;
          }
        }
      }
    }
  }

  var len = arr.length,
      j;
  var tempExchangVal;
  while (len > 0) {
    for (j = 0; j < len - 1; j++) {
      if (typeSort == 'small') {
        if (arr[j][key] > arr[j + 1][key]) {
          tempExchangVal = arr[j];
          arr[j] = arr[j + 1];
          arr[j + 1] = tempExchangVal;
        }
      } else {
        if (arr[j][key] < arr[j + 1][key]) {
          tempExchangVal = arr[j];
          arr[j] = arr[j + 1];
          arr[j + 1] = tempExchangVal;
        }
      }
    }
    len--;
  }
  return arr;
};

/***/ }),

/***/ "rLAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("nQpb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0a1c9447_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("zo+p");
function injectStyle (ssrContext) {
  __webpack_require__("TVno")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0a1c9447_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tHJd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return apiMyPages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return apiAlbumSeries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return apiImgNewHot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return apiThumbUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return apiStampsDetail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apiConfig_js__ = __webpack_require__("yKQW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_const__ = __webpack_require__("GwN5");
/**
 * album api
 */



/**
 * 获取邮册信息  翻转
 */
var apiMyPages = function apiMyPages(options, callback) {
  return __WEBPACK_IMPORTED_MODULE_0__apiConfig_js__["a" /* $axios */].get('/pages/myPages', options ? options : {});
};

/**
 * 获取某某系列邮票   邮册详情—单票列表
 */

var apiAlbumSeries = function apiAlbumSeries() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__apiConfig_js__["a" /* $axios */])({
    url: '/pages/' + options.id
  });
};

/**
 * 邮册最新 最热
 */
var apiImgNewHot = function apiImgNewHot() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__apiConfig_js__["a" /* $axios */])({
    type: 'get',
    url: '/pages/rank',
    params: options.params
  });
};

/*
 *  邮册 点赞
 * */

var apiThumbUp = function apiThumbUp() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__apiConfig_js__["a" /* $axios */])({
    type: 'get',
    url: '/shares/likes/' + options.id
  });
};

/*
 *  邮册 详情
 * */

var apiStampsDetail = function apiStampsDetail() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__apiConfig_js__["a" /* $axios */])({
    type: 'get',
    url: '/pages/' + options.id
  });
};

/***/ }),

/***/ "tok3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator__ = __webpack_require__("Zzip");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol__ = __webpack_require__("5QVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol__);





var _typeof = "function" == typeof __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol___default.a && "symbol" == __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator___default.a) ? function (t) {
  return typeof t === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(t);
} : function (t) {
  return t && "function" == typeof __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol___default.a && t.constructor === __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol___default.a && t !== __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol___default.a.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(t);
};!function (t, e) {
  var i = function t(e, i) {
    return t.fn.init(e, i);
  };i.fn = i.prototype = { constructor: i, setting: { btnText: "确认", info: "提示信息" }, setResult: {}, init: function init(t, e) {
      if (this.setResult = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.setting)), "string" == typeof t || "number" == typeof t || "boolean" == typeof t) this.setResult.info = t;else {
        if ("object" != (void 0 === t ? "undefined" : _typeof(t))) return;for (var i in t) {
          this.setResult[i] = t[i];
        }
      }e && (this.success = e), this.bg ? this.refresh() : this.created();
    }, refresh: function refresh() {
      this.infoDIv.innerText = this.setResult.info, this.btnDiv.innerText = this.setResult.btnText, this.show();
    }, created: function created() {
      this.bg = document.createElement("div"), this.bg.className = "bg-alt", this.wrap = document.createElement("div"), this.wrap.className = "wrap-alt", this.infoDIv = document.createElement("div"), this.infoDIv.className = "info-alt", this.infoDIv.innerText = this.setResult.info, this.btnDiv = document.createElement("div"), this.btnDiv.className = "btn-alt", this.btnDiv.innerText = this.setResult.btnText, this.wrap.appendChild(this.infoDIv), this.wrap.appendChild(this.btnDiv), this.bg.appendChild(this.wrap), document.body.appendChild(this.bg), this.save();
    }, save: function save() {
      var t = this;this.btnDiv.onclick = function () {
        t.hide(), t.success();
      };
    }, success: function success() {}, hide: function hide() {
      this.bg.style.display = "none";
    }, show: function show() {
      this.bg.style.display = "block";
    } }, i.fn.init.prototype = i.fn, "object" === (void 0 === t ? "undefined" : _typeof(t)) && "object" === _typeof(t.document) && (t.alt = i);
}(window);

/***/ }),

/***/ "tyhV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_mutation_types__ = __webpack_require__("iMSY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_const__ = __webpack_require__("GwN5");



var _mutations;

// src/store/modules/account.js



__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);





var state = {
    apiInfo: '',
    apiMobileInfo: ''
};

var getters = {
    getLogin: function getLogin(state) {
        return state.apiInfo;
    },
    getMobileLogin: function getMobileLogin(state) {
        return state.apiMobileInfo;
    }
};

var actions = {
    getMobileLogin: function getMobileLogin(_ref, options) {
        var commit = _ref.commit;

        var uri = __WEBPACK_IMPORTED_MODULE_5__config_const__["b" /* API_AI */] + "/h5/auth/mobileLogin";
        if (options.data.from && options.data.redirect) {
            uri += '?from=' + options.data.from + '&redirect=' + options.data.redirect;
        }
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post(uri, {
                mobilePhone: options.data.mobile,
                validationCode: options.data.msgcode
            }).then(function (res, err) {
                resolve(res.data);
            }, function (res) {
                reject(res.data);
            });
        }).then(function (res) {
            commit(__WEBPACK_IMPORTED_MODULE_4__config_mutation_types__["h" /* API_MOBILE_LOGIN_INFO */], res);
        }, function (err) {
            commit(__WEBPACK_IMPORTED_MODULE_4__config_mutation_types__["r" /* APP_MOBILE_LOGIN_FAILURE */], err + '获取信息失败');
        });
    },
    getLogin: function getLogin(_ref2, options) {
        var commit = _ref2.commit;

        //var uri = "http://192.168.16.149:15005/h5/auth/"
        var uri = __WEBPACK_IMPORTED_MODULE_5__config_const__["b" /* API_AI */] + "/h5/auth";
        if (options.data.from && options.data.redirect) {
            uri += '?from=' + options.data.from + '&redirect=' + options.data.redirect;
        }
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post(uri, {
                username: options.data.username,
                password: options.data.password
            }).then(function (res, err) {
                resolve(res.data);
            }, function (res) {
                reject(res.data);
            });
        }).then(function (res) {
            commit(__WEBPACK_IMPORTED_MODULE_4__config_mutation_types__["g" /* API_LOGIN_INFO */], res);
        }, function (err) {
            commit(__WEBPACK_IMPORTED_MODULE_4__config_mutation_types__["q" /* APP_LOGIN_FAILURE */], err + '获取信息失败');
        });
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__config_mutation_types__["g" /* API_LOGIN_INFO */], function (state, data) {
    state.apiInfo = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__config_mutation_types__["q" /* APP_LOGIN_FAILURE */], function (state, data) {
    state.apiInfo = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__config_mutation_types__["h" /* API_MOBILE_LOGIN_INFO */], function (state, data) {
    state.apiMobileInfo = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__config_mutation_types__["r" /* APP_MOBILE_LOGIN_FAILURE */], function (state, data) {
    state.apiMobileInfo = data;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ "vz0Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_mutation_types__ = __webpack_require__("iMSY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_const__ = __webpack_require__("GwN5");



var _mutations;

// src/store/modules/account.js



__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);





var state = {
    apiInfo: ''
};

var getters = {
    getMsgCode: function getMsgCode(state) {
        return state.apiInfo;
    }
};

var actions = {
    getMsgCode: function getMsgCode(_ref, options) {
        var commit = _ref.commit;

        var uri = __WEBPACK_IMPORTED_MODULE_5__config_const__["b" /* API_AI */] + "/h5/auth/sendLoginCaptcha";
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post(uri, {
                mobilePhone: options.data.mobileData
            }).then(function (res, err) {
                resolve(res.data);
            }, function (res) {
                reject(res.data);
            });
        }).then(function (res) {
            commit(__WEBPACK_IMPORTED_MODULE_4__config_mutation_types__["i" /* API_MSGCODE_INFO */], res);
        }, function (err) {
            commit(__WEBPACK_IMPORTED_MODULE_4__config_mutation_types__["s" /* APP_MSGCODE_FAILURE */], err + '获取信息失败');
        });
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__config_mutation_types__["i" /* API_MSGCODE_INFO */], function (state, data) {
    state.apiInfo = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__config_mutation_types__["s" /* APP_MSGCODE_FAILURE */], function (state, data) {
    state.apiInfo = data;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ "xzd6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      isShowRefresh: false,
      isKeepAlive: false
    };
  },
  created: function created() {
    this.isShowRefresh = window.location.hostname == 'm.ytgrading.com' ? false : true;
  },

  watch: {
    '$route': 'routeChange'
  },
  methods: {
    routeChange: function routeChange() {
      document.title = this.$route.meta.title;
      this.isKeepAlive = this.$route.meta.keepAlive;
    }
  }
});

/***/ }),

/***/ "yKQW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return $axios; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_const__ = __webpack_require__("GwN5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__("L/hj");

/**
 * Created by wumian on 2018/2/5.
 */





var $axios = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  baseURL: __WEBPACK_IMPORTED_MODULE_2__config_const__["b" /* API_AI */]
});

var debug = "production" != 'production';

// 添加请求拦截器
$axios.interceptors.request.use(function (config) {
  var appId = __WEBPACK_IMPORTED_MODULE_3__utils__["c" /* Cookie */].get('appId') || 'fKhnk3UwbjhLP5NuFNQm5W';
  var appKey = __WEBPACK_IMPORTED_MODULE_3__utils__["c" /* Cookie */].get('appKey') || '9dbe75e0-d10a-55a5-b232-ecd60a9f60be';
  var deviceId = __WEBPACK_IMPORTED_MODULE_3__utils__["c" /* Cookie */].get('deviceId') || 'a7db4c9407af622a';
  var userId = __WEBPACK_IMPORTED_MODULE_3__utils__["c" /* Cookie */].get('userId') || '';
  var authorization = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* Authentication */])(appId, appKey, deviceId, config.method, config.url);
  config.headers['X-Zhao-AppId'] = appId;
  config.headers['X-Zhao-DeviceId'] = deviceId;
  config.headers['X-Zhao-UserId'] = userId;
  config.headers['X-Zhao-OSInfo'] = '{"os":"h5"}';

  if (debug) {
    config.headers['X-Zhao-Test'] = '8136135'; //8142814
  }

  config.headers['Authorization'] = authorization;
  return config;
}, function (err) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
});


/* unused harmony default export */ var _unused_webpack_default_export = ($axios);

/***/ }),

/***/ "zo+p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.246f704396c3636dadc9.js